"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6337],{

/***/ 95205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TotalFundraiseValues; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var _lib_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41181);



var TotalFundraiseValues = function(props) {
    var ref;
    var unitNumber = (0,_lib_number__WEBPACK_IMPORTED_MODULE_0__/* .toUnitNumber */ .Fk)(props.value);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("display:flex;justify-content:end;"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
                className: "currency",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("margin-right:2px;"),
                children: props.currency
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
                className: "value",
                children: (ref = unitNumber.value) === null || ref === void 0 ? void 0 : ref.toFixed(1)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
                className: "unit",
                children: unitNumber.unit
            })
        ]
    });
};


/***/ }),

/***/ 63043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ OpenCloseToggle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);






var OpenCloseToggle = function(_param) {
    var status = _param.status, isLarge = _param.isLarge, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "status",
        "isLarge",
        "onClick"
    ]);
    var fontSize = isLarge ? "24px" : "20px";
    var color = status === "open" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray70 */ .O9.gray70 : status === "closed" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.blue50 */ .O9.blue50 : plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray50 */ .O9.gray50;
    var iconName = status === "open" ? "minus-square-fill" : "plus-square-fill";
    var cursorStyle = status === "disabled" ? "normal" : "pointer";
    var handleClick = function() {
        if (status === "disabled") {
            return;
        }
        return onClick();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("line-height:0;"),
        onClick: handleClick,
        id: props.id,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: iconName,
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";color:", color, ";font-size:", fontSize, ";cursor:", cursorStyle, ";")
        })
    });
};


/***/ }),

/***/ 56337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ company_CompanyPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/atoms/CardTitle.tsx
var CardTitle = __webpack_require__(4336);
// EXTERNAL MODULE: ./components/common/Head.tsx
var Head = __webpack_require__(12912);
// EXTERNAL MODULE: ./components/common/Template.tsx
var Template = __webpack_require__(33431);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var lib_date = __webpack_require__(57923);
// EXTERNAL MODULE: ./lib/number.ts
var number = __webpack_require__(41181);
// EXTERNAL MODULE: ./components/atoms/CardInnerTitle.tsx
var CardInnerTitle = __webpack_require__(73367);
// EXTERNAL MODULE: ./components/atoms/DescriptionList.tsx
var DescriptionList = __webpack_require__(53156);
// EXTERNAL MODULE: ./components/pages/investor/DoubleColumnContent.tsx
var DoubleColumnContent = __webpack_require__(31302);
;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyFinanceInfo.tsx









var CompanyFinanceInfo = function(props) {
    var formattedCommonStock = (0,number/* formatAmount */.dN)(props.info.commonStock);
    var formattedCapitalReserve = (0,number/* formatAmount */.dN)(props.info.capitalReserve);
    var formattedCapitalAndReserve = (0,number/* formatAmount */.dN)(props.info.capitalAndReserve);
    var formattedCapitalReduction = (0,number/* formatAmount */.dN)(props.info.capitalReduction);
    var formattedTotalFunding = (0,number/* formatAmount */.dN)(props.info.totalFunding);
    var formattedFullyDilutedLatestValuation = (0,number/* formatAmount */.dN)(props.info.fullyDilutedLatestValuation);
    var formattedOtherFundigEquity = (0,number/* formatAmount */.dN)(parseIntForAmount(props.info.otherFundigEquity));
    var formattedOtherFundingDebt = (0,number/* formatAmount */.dN)(parseIntForAmount(props.info.otherFundingDebt));
    var postMoneyValuationLabel = props.withoutDilutiveShares ? "調達後評価額（潜在株を含まない）" : "調達後評価額（潜在株を含む）";
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "基本情報"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DoubleColumnContent/* DoubleColumnContent */.D, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                        list: {
                            資本準備金の有無: {
                                text: props.info.capitalReserveStatus
                            },
                            資本金: {
                                text: formattedCommonStock ? "".concat(formattedCommonStock.value).concat(formattedCommonStock.unit) : ""
                            },
                            資本準備金: {
                                text: formattedCapitalReserve ? "".concat(formattedCapitalReserve.value).concat(formattedCapitalReserve.unit) : ""
                            },
                            "資本金+資本準備金": {
                                text: formattedCapitalAndReserve ? "".concat(formattedCapitalAndReserve.value).concat(formattedCapitalAndReserve.unit) : ""
                            },
                            減資の有無: {
                                text: props.info.capitalReductionStatus
                            },
                            減資額: {
                                text: formattedCapitalReduction ? "".concat(formattedCapitalReduction.value).concat(formattedCapitalReduction.unit) : ""
                            },
                            "その他の調達 (equity)": {
                                text: props.info.otherFundigEquity && formattedOtherFundigEquity ? "".concat(formattedOtherFundigEquity.value).concat(formattedOtherFundigEquity.unit) : "",
                                help: "資本金、準備金に含まれていない新株予約権付社債、転換社債、\nConvertible Notesの発行等のequity投資の金額"
                            },
                            総調達額: {
                                text: formattedTotalFunding ? "".concat(formattedTotalFunding.value).concat(formattedTotalFunding.unit) : ""
                            },
                            "その他の調達 (debt)": {
                                text: props.info.otherFundingDebt && formattedOtherFundingDebt ? "".concat(formattedOtherFundingDebt.value).concat(formattedOtherFundingDebt.unit) : "",
                                help: "短期借入(Loan)、長期借入(Debt)、\nリワード型のクラウドファンディング、普通社債等"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                        className: "finance-section-right",
                        list: (_obj = {
                            "登記簿情報 反映日": {
                                text: props.info.fundingRoundLastUpdatedByRegistrationCertificate && (0,lib_date/* formatDate */.p6)(props.info.fundingRoundLastUpdatedByRegistrationCertificate, "yyyy/MM/dd")
                            },
                            評価額算出ラウンド実施日: {
                                text: props.info.lastValuationDate && (0,lib_date/* formatDate */.p6)(props.info.lastValuationDate, "yyyy/MM/dd")
                            }
                        }, (0,_define_property/* default */.Z)(_obj, postMoneyValuationLabel, {
                            text: formattedFullyDilutedLatestValuation ? "".concat(formattedFullyDilutedLatestValuation.value).concat(formattedFullyDilutedLatestValuation.unit) : ""
                        }), (0,_define_property/* default */.Z)(_obj, "融資情報", {
                            text: props.info.privateLoan,
                            help: "銀行などからの融資・ローン・負債など"
                        }), (0,_define_property/* default */.Z)(_obj, "決算月", {
                            text: props.info.settlementMonth
                        }), _obj)
                    })
                ]
            })
        ]
    });
};
var parseIntForAmount = function(s) {
    if (s) {
        return parseInt(s.replace(/,/g, ""), 10);
    }
    return null;
};

// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./lib/company.ts
var lib_company = __webpack_require__(10133);
// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
// EXTERNAL MODULE: ./pages/_error.tsx
var _error = __webpack_require__(61753);
// EXTERNAL MODULE: ./components/common/MobileGuestFloatingBanner.tsx
var MobileGuestFloatingBanner = __webpack_require__(20438);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./components/common/MobileGuestSlideBanner.tsx
var MobileGuestSlideBanner = __webpack_require__(54146);
// EXTERNAL MODULE: ./components/common/ThumbnailFloatingBanner.tsx + 1 modules
var ThumbnailFloatingBanner = __webpack_require__(65013);
// EXTERNAL MODULE: ./components/common/npStartup/NewsPicksStaticBanner.tsx
var NewsPicksStaticBanner = __webpack_require__(5836);
// EXTERNAL MODULE: ./components/pages/company/molecules/domestic/CompanyTabGroup.tsx
var CompanyTabGroup = __webpack_require__(14224);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./lib/wovn.ts
var wovn = __webpack_require__(15598);
// EXTERNAL MODULE: ./components/atoms/A.tsx
var A = __webpack_require__(20932);
// EXTERNAL MODULE: ./components/atoms/SNSLinks.tsx + 1 modules
var SNSLinks = __webpack_require__(33879);
// EXTERNAL MODULE: ./components/pages/company/molecules/DatasourceLink.tsx
var DatasourceLink = __webpack_require__(56279);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/max/index.js
var max = __webpack_require__(99890);
// EXTERNAL MODULE: ./lib/api/company.ts
var company = __webpack_require__(58124);
// EXTERNAL MODULE: ./lib/log.ts
var log = __webpack_require__(79240);
// EXTERNAL MODULE: ./components/atoms/Modal.tsx
var Modal = __webpack_require__(99338);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(97762);
;// CONCATENATED MODULE: ./lib/ts-utils.ts
var assertNever = function(x) {
    throw new Error("Unexpected case" + x);
};

;// CONCATENATED MODULE: ./components/pages/company/chart/CustomTooltip.tsx



// Note: React18以上だとReactDOMServer.renderToStaticMarkupでHTMLに変換された際に、
// emotionのcssが適用されないのでstyleによってスタイルを設定している
// ref: https://github.com/emotion-js/emotion/issues/3008
var CustomTooltip = function(props) {
    var _value;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        style: {
            padding: "12px 20px",
            borderRadius: "0 !important",
            backgroundColor: "rgba(255, 255, 255, 0.5)"
        },
        className: "custom-tooltip ".concat(props.className ? props.className : ""),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                style: {
                    color: dist/* colors.gray70 */.O9.gray70,
                    fontSize: "12px"
                },
                children: props.date
            }),
            props.items.map(function(item, i) {
                var ref;
                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                marginTop: i > 0 ? "15px" : "5px"
                            },
                            children: [
                                item.color && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    style: {
                                        width: "16px",
                                        height: "16px",
                                        borderRadius: "50%",
                                        backgroundColor: item.color,
                                        opacity: 0.8,
                                        marginRight: "6px"
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    style: {
                                        color: dist/* colors.text */.O9.text,
                                        fontWeight: "bold",
                                        fontSize: "14px"
                                    },
                                    children: item.title
                                })
                            ]
                        }),
                        item.dict && item.dict.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            style: {
                                marginTop: "10px"
                            },
                            children: (ref = item.dict) === null || ref === void 0 ? void 0 : ref.map(function(d, i) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "start",
                                        marginTop: "5px",
                                        justifyContent: "space-between"
                                    },
                                    children: [
                                        d.label && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            style: {
                                                fontSize: "12px",
                                                color: dist/* colors.text */.O9.text
                                            },
                                            children: [
                                                d.label,
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            style: {
                                                color: dist/* colors.text */.O9.text,
                                                fontWeight: "bold",
                                                fontSize: "13px",
                                                marginLeft: "3px"
                                            },
                                            children: [
                                                (_value = d.value) !== null && _value !== void 0 ? _value : "不明",
                                                d.value && d.unit && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    style: {
                                                        color: dist/* colors.gray80 */.O9.gray80,
                                                        fontSize: "11px",
                                                        marginLeft: "2px"
                                                    },
                                                    children: d.unit
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        }),
                        item.text && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            style: {
                                marginTop: "5px",
                                maxWidth: "170px",
                                whiteSpace: "pre-wrap",
                                lineHeight: 1.4
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                style: {
                                    fontSize: "12px",
                                    color: dist/* colors.text */.O9.text
                                },
                                children: item.text
                            })
                        })
                    ]
                }, i);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/company/chart/DonutChart.tsx









var Chart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5279), __webpack_require__.e(7229)]).then(__webpack_require__.bind(__webpack_require__, 47229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47229)
            ];
        }
    },
    ssr: false
});
var DonutChart = function(props) {
    var categories = Object.entries(props.data).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
        return v ? k : undefined;
    }).filter(function(k) {
        return k !== undefined;
    });
    var colors = categories.map(props.colorFn);
    var values = Object.values(props.data).filter(function(v) {
        return v !== null && v !== 0;
    });
    var total = values.reduce(function(a, b) {
        return a + b;
    }, 0);
    var options = {
        labels: categories,
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2
        },
        legend: {
            show: categories.length > 0,
            markers: {
                fillColors: colors
            }
        },
        fill: {
            colors: colors
        },
        title: {
            text: props.title
        },
        noData: {
            text: "表示するデータがありません",
            align: "left",
            style: {
                color: dist/* colors.gray70 */.O9.gray70,
                fontSize: "13px"
            }
        },
        tooltip: {
            custom: function(param) {
                var seriesIndex = param.seriesIndex;
                return props.tooltipFn(props.data, total, seriesIndex, props.colorFn);
            },
            theme: "light"
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "50%"
                },
                expandOnClick: false
            }
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chart, {
            type: "donut",
            width: 320,
            series: values,
            options: options
        })
    });
};
var PrivateFundraiseChart = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DonutChart, {
        title: "総調達額の内訳(過去分含む）",
        data: props.data,
        colorFn: colorOfPrivateFundingCategory,
        tooltipFn: tooltipHTMLOfFundraise
    });
};
var IPOFundraiseChart = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DonutChart, {
        title: "総調達額の内訳（IPO前）",
        data: props.data,
        colorFn: colorOfIPOCategory,
        tooltipFn: tooltipHTMLOfFundraise,
        className: props.className
    });
};
var IPOShareChart = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DonutChart, {
        title: "株式比率（IPO前）",
        data: props.data,
        colorFn: colorOfIPOCategory,
        tooltipFn: tooltipHTMLOfShare,
        className: props.className
    });
};
var tooltipHTMLOfFundraise = function(ratio, total, targetIndex, colorFn) {
    if (!ratio) {
        return null;
    }
    var target = Object.entries(ratio)[targetIndex];
    var percentage = Math.round(target[1] / total * 100 * 10) / 10;
    var items = [
        {
            title: target[0],
            color: colorFn(target[0]),
            dict: [
                {
                    label: "調達額",
                    value: (0,number/* formatWithComma */.m$)((0,number/* thousandToMillion */.Km)(target[1])),
                    unit: "百万円"
                },
                {
                    label: "割合",
                    value: percentage,
                    unit: "%"
                }, 
            ]
        }, 
    ];
    return server_browser/* renderToStaticMarkup */.uS(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomTooltip, {
        items: items
    }));
};
var tooltipHTMLOfShare = function(ratio, total, targetIndex, colorFn) {
    if (!ratio) {
        return null;
    }
    var target = Object.entries(ratio)[targetIndex];
    var percentage = Math.round(target[1] / total * 100 * 10) / 10;
    var item = [
        {
            title: target[0],
            color: colorFn(target[0]),
            dict: [
                {
                    label: "割合",
                    value: percentage,
                    unit: "%"
                }, 
            ]
        }, 
    ];
    return server_browser/* renderToStaticMarkup */.uS(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomTooltip, {
        items: item
    }));
};
var colorOfPrivateFundingCategory = function(c) {
    switch(c){
        case "VC":
            return "#000667";
        case "金融機関":
            return "#004db0";
        case "事業法人":
            return "#008dd2";
        case "海外VC":
            return "#2dbaf0";
        case "海外金融機関":
            return "#5ed8e0";
        case "海外事業法人":
            return "#b4e3e4";
        case "個人/個人会社":
            return "#8797ae";
        case "その他":
            return "#d7dce4";
        default:
            return assertNever(c);
    }
};
var colorOfIPOCategory = function(c) {
    switch(c){
        case "VC":
            return "#000667";
        case "事業会社":
            return "#008dd2";
        case "個人":
            return "#8797ae";
        default:
            return assertNever(c);
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./lib/page.ts
var lib_page = __webpack_require__(86234);
;// CONCATENATED MODULE: ./components/pages/company/chart/HorizontalEventsChart.tsx












var HorizontalEventsChart_Chart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5279), __webpack_require__.e(7229)]).then(__webpack_require__.bind(__webpack_require__, 47229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47229)
            ];
        }
    },
    ssr: false
});
var HorizontalEventsChart = function(props) {
    var series = seriesOf(props.data, props.endDate);
    var handleDataPointSelection = function(_e, _ctx, param) {
        var dataPointIndex = param.dataPointIndex, seriesIndex = param.seriesIndex;
        var selectedSeries = seriesIndex === 0 ? "events" : "news";
        if (selectedSeries === "events") {
            var selectedDataPoint = props.data.events[dataPointIndex - 1];
            if (selectedDataPoint.type === "住所変更") {
                return (0,lib_page/* scrollToId */.E6)("address-histories", {
                    offset: 100
                });
            } else if (selectedDataPoint.type === "IPO") {
                return (0,lib_page/* scrollToId */.E6)("ipo-data");
            } else {
                window.open(selectedDataPoint.item.path);
            }
        } else {
            var selectedDataPoint1 = props.data.news[dataPointIndex - 1];
            if (selectedDataPoint1.type === "ファイナンス・M&A") {
                window.open(selectedDataPoint1.item.path);
            } else {
                window.open(selectedDataPoint1.item.url);
            }
        }
    };
    var hiddenMarkers = [
        {
            seriesIndex: 0,
            dataPointIndex: 0,
            size: 0
        },
        {
            seriesIndex: 0,
            dataPointIndex: series[0].data.length - 1,
            size: 0
        },
        {
            seriesIndex: 1,
            dataPointIndex: 0,
            size: 0
        },
        {
            seriesIndex: 1,
            dataPointIndex: series[1].data.length - 1,
            size: 0
        }, 
    ];
    var options = {
        chart: {
            type: "line",
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            },
            events: {
                dataPointSelection: handleDataPointSelection
            }
        },
        stroke: {
            width: 0
        },
        grid: {
            show: false,
            xaxis: {
                lines: {
                    show: false
                }
            }
        },
        xaxis: {
            type: "datetime",
            labels: {
                show: false
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            tooltip: {
                enabled: false
            }
        },
        yaxis: {
            labels: {
                show: false
            }
        },
        legend: {
            show: false
        },
        markers: {
            size: 8,
            shape: "square",
            colors: [
                dist/* colors.red50 */.O9.red50,
                dist/* colors.blueGray40 */.O9.blueGray40
            ],
            hover: {
                size: 8
            },
            strokeWidth: 0,
            discrete: hiddenMarkers,
            fillOpacity: 0.6
        },
        tooltip: {
            shared: false,
            intersect: true,
            enabledOnSeries: false,
            onDatasetHover: {
                highlightDataSeries: false
            },
            custom: function(param) {
                var dataPointIndex = param.dataPointIndex, seriesIndex = param.seriesIndex;
                var series = seriesIndex === 0 ? "events" : "news";
                return tooltipHTMLOf(props.data, series, dataPointIndex);
            }
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;margin-bottom:-20px;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;line-height:19px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";color:", dist/* colors.text */.O9.text, ";margin-bottom:22px;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: "イベント"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:5px;"),
                        children: "ニュース"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:22px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalEventsChart_Chart, {
                    type: "line",
                    width: 1000,
                    height: 80,
                    series: series,
                    options: options
                })
            })
        ]
    });
};
var seriesOf = function(data, endDate) {
    var ref;
    var start = (ref = data.fundingRounds[0]) === null || ref === void 0 ? void 0 : ref.date;
    var end = endDate.toISOString();
    var eventDates = data.events.filter(function(item) {
        return (0,parseISO["default"])(item.date) <= endDate;
    }).map(function(item) {
        return item.date;
    });
    var newsDates = data.news.filter(function(item) {
        return (0,parseISO["default"])(item.date) <= endDate;
    }).map(function(item) {
        return item.date;
    });
    var eventsData = [
        start
    ].concat((0,_to_consumable_array/* default */.Z)(eventDates), [
        end
    ]).map(function(date) {
        return [
            (0,parseISO["default"])(date).getTime(),
            50, 
        ];
    });
    var newsData = [
        start
    ].concat((0,_to_consumable_array/* default */.Z)(newsDates), [
        end
    ]).map(function(date) {
        return [
            (0,parseISO["default"])(date).getTime(),
            30, 
        ];
    });
    return [
        {
            name: "events",
            data: eventsData
        },
        {
            name: "news",
            data: newsData
        }, 
    ];
};
var tooltipHTMLOf = function(data, series, targetIndex) {
    switch(series){
        case "events":
            var event = data.events.find(function(n) {
                var ref;
                return (0,isSameDay["default"])((0,parseISO["default"])(n.date), (0,parseISO["default"])((ref = data.events[targetIndex - 1]) === null || ref === void 0 ? void 0 : ref.date));
            });
            if (!event) {
                return null;
            }
            return server_browser/* renderToStaticMarkup */.uS(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomTooltip, {
                date: (0,lib_date/* formatDate */.p6)(event.date, "yyyy/MM/dd"),
                items: [
                    {
                        title: event.type,
                        text: eventTooltipText(event)
                    }, 
                ]
            }));
        case "news":
            var news = data.news.find(function(n) {
                var ref;
                return (0,isSameDay["default"])((0,parseISO["default"])(n.date), (0,parseISO["default"])((ref = data.news[targetIndex - 1]) === null || ref === void 0 ? void 0 : ref.date));
            });
            if (!news) {
                return null;
            }
            return server_browser/* renderToStaticMarkup */.uS(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomTooltip, {
                date: (0,lib_date/* formatDate */.p6)(news.date, "yyyy/MM/dd"),
                items: [
                    {
                        title: news.type,
                        text: news.item.title
                    }
                ]
            }));
    }
};
var eventTooltipText = function(e) {
    if (e.type === "住所変更") {
        return e.item.address;
    }
    if (e.type === "IPO") {
        return e.item.market;
    }
    switch(e.type){
        case "事業提携":
        case "事業譲受":
        case "事業譲渡":
        case "被買収・子会社化・主要株式取得":
            var ref, ref1, ref2, ref3;
            var ref4;
            return (ref4 = (ref = e.item.roundDetails) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gpInvestors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name) !== null && ref4 !== void 0 ? ref4 : e.item.remarks;
        case "合併（M&A,事業継承など）":
            return e.item.remarks;
        case "創業":
        case "会社設立":
        case "破綻・清算・解散":
            return null;
        default:
            return assertNever(e);
    }
};

// EXTERNAL MODULE: ./components/pages/company/molecules/EmptyNumber.tsx
var EmptyNumber = __webpack_require__(62610);
// EXTERNAL MODULE: ./node_modules/d3-scale/src/log.js + 37 modules
var src_log = __webpack_require__(3858);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js
var endOfMonth = __webpack_require__(4135);
// EXTERNAL MODULE: ./components/atoms/Table.tsx
var Table = __webpack_require__(14792);
// EXTERNAL MODULE: ./components/common/EmptyCard.tsx
var EmptyCard = __webpack_require__(23581);
// EXTERNAL MODULE: ./components/common/Help.tsx
var Help = __webpack_require__(33869);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
;// CONCATENATED MODULE: ./components/common/LimitedToEnterpriseContents.tsx







var LimitedToEnterpriseContents = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";line-height:175%;letter-spacing:0.02em;color:", dist/* colors.text */.O9.text, ";", dist.mq.untilMedium, "{font-size:14px;}", dist.mq.large, "{font-size:14px;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                name: "lock-fill",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textStrong */.O9.textStrong, ";font-size:14px;margin-right:4px;")
            }),
            "有料契約限定のコンテンツです。",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                href: url/* trialRequestUrl */.d1,
                target: "blank",
                decoration: "none",
                children: "無料トライアルに申し込む"
            }),
            "とご覧になれます。"
        ]
    });
};

// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
;// CONCATENATED MODULE: ./components/pages/company/molecules/EmployeesShiftTable.tsx










var EmployeesShiftTable = function(props) {
    if (!props.isEnterprise) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:", props.isEnterprise ? "initial" : "none", ";}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "年月日"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                children: [
                                    "区分",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                        children: "従業員数の集計方法"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                children: [
                                    "従業員数",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                        children: "臨時雇用者を含みます"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "出所"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "備考"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:flex;justify-content:center;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                            colSpan: 6,
                            align: "center",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LimitedToEnterpriseContents, {})
                        })
                    })
                })
            ]
        });
    }
    if (props.employeesShift.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "年月日"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                            children: [
                                "区分",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                    children: "従業員数の集計方法"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                            children: [
                                "従業員数",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                    children: "臨時雇用者を含みます"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "出所"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "備考"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                children: props.employeesShift.map(function(data, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        id: employeesShiftTableRecordId(data),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: data.dateType
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                    children: data.eventDate
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: data.reportType
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableCell */.pj, {
                                children: [
                                    data.count.toLocaleString(),
                                    "人"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: data.sourceUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                    href: data.sourceUrl,
                                    target: "_blank",
                                    rel: "noopener",
                                    decoration: "none",
                                    children: data.sourceType
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: data.sourceType
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: data.remarks
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
var employeesShiftTableRecordId = function(employeesShiftData) {
    return "employees-".concat(employeesShiftData.eventDate, "-").concat(employeesShiftData.reportType);
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/FundingRoundAndEmployeeTransitionChart.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: rgba(255, 255, 255, 0.5);\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: rgba(255, 255, 255, 0.5);\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var FundingRoundAndEmployeeTransitionChart_Chart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5279), __webpack_require__.e(7229)]).then(__webpack_require__.bind(__webpack_require__, 47229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47229)
            ];
        }
    },
    ssr: false
});
var FundingRoundAndEmployeeTransitionChart = function(props) {
    var markers = markersOfFundingRounds(props.fundingRounds);
    var initialSeriesAnnotations = annotationsOfFundingRounds(props.fundingRounds);
    var hasEmployeesData = props.employeesShift.length > 0;
    var employeesShiftMaxByDate = filterMaxCountByDate(props.employeesShift);
    var fundingRoundsOptions = {
        stroke: {
            curve: "stepline",
            dashArray: 0
        },
        yaxis: {
            decimalsInFloat: 0,
            seriesName: "総調達額（百万円）",
            title: {
                text: "総調達額（百万円）",
                rotate: 0,
                offsetX: 65,
                offsetY: -185,
                style: {
                    fontSize: "12px",
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontWeight: 300
                }
            },
            labels: {
                formatter: function(v) {
                    return (0,number/* formatWithComma */.m$)((0,number/* thousandToMillion */.Km)(v));
                }
            },
            axisBorder: {
                offsetX: 5
            }
        },
        markers: {
            size: 1,
            colors: undefined
        },
        tooltip: {
            custom: function(param) {
                var dataPointIndex = param.dataPointIndex;
                return tooltipHTMLOfFundingRounds(props.fundingRounds, dataPointIndex);
            }
        }
    };
    var employeesOptions = {
        stroke: {
            curve: "straight",
            dashArray: 3
        },
        yaxis: {
            show: hasEmployeesData,
            opposite: true,
            seriesName: "従業員数（人）",
            title: {
                text: "従業員数（人）",
                rotate: 0,
                offsetX: -40,
                offsetY: -185,
                style: {
                    fontSize: "12px",
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontWeight: 300
                }
            },
            axisBorder: {
                show: false
            }
        },
        markers: {
            size: 5,
            colors: colorOfRound("従業員数")
        },
        tooltip: {
            custom: function(param) {
                var dataPointIndex = param.dataPointIndex;
                return tooltipHTMLOfEmployees(employeesShiftMaxByDate, dataPointIndex);
            }
        }
    };
    // see https://apexcharts.com/docs/options/
    var options = {
        chart: {
            type: "line",
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            },
            events: {
                markerClick: function(_event, _chartContext, param) {
                    var dataPointIndex = param.dataPointIndex, seriesIndex = param.seriesIndex;
                    var isFundingRoundMarker = seriesIndex === 0;
                    var elm = isFundingRoundMarker ? document.getElementById(props.fundingRounds[dataPointIndex].shortname) : document.getElementById(employeesShiftTableRecordId(employeesShiftMaxByDate[dataPointIndex]));
                    if (elm) {
                        var NAVBAR_HEIGHT = 215;
                        var top = elm.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT;
                        window.scroll({
                            top: top,
                            behavior: "smooth"
                        });
                    }
                }
            }
        },
        stroke: {
            curve: [
                fundingRoundsOptions.stroke.curve,
                employeesOptions.stroke.curve
            ],
            width: 2,
            lineCap: "round",
            dashArray: [
                fundingRoundsOptions.stroke.dashArray,
                employeesOptions.stroke.dashArray, 
            ]
        },
        colors: [
            dist/* colors.black10 */.O9.black10
        ],
        xaxis: {
            type: "datetime",
            labels: {
                datetimeFormatter: {
                    year: "yyyy",
                    // Show only year value
                    month: ""
                }
            },
            axisBorder: {
                show: true,
                color: dist/* colors.black10 */.O9.black10,
                height: 2
            },
            axisTicks: {
                show: false
            },
            tooltip: {
                enabled: false
            }
        },
        yaxis: [
            fundingRoundsOptions.yaxis,
            employeesOptions.yaxis
        ],
        markers: {
            size: [
                fundingRoundsOptions.markers.size,
                employeesOptions.markers.size
            ],
            strokeWidth: 0,
            hover: {
                size: undefined
            },
            colors: [
                fundingRoundsOptions.markers.colors,
                employeesOptions.markers.colors, 
            ],
            discrete: markers
        },
        tooltip: {
            custom: [
                fundingRoundsOptions.tooltip.custom,
                employeesOptions.tooltip.custom, 
            ]
        },
        annotations: {
            position: "back",
            xaxis: initialSeriesAnnotations
        },
        legend: {
            show: false
        }
    };
    var series = [
        {
            text: "総調達額（百万円）",
            data: seriesOfFundingRounds(props.fundingRounds, props.endDate)
        },
        {
            name: "従業員数（人）",
            data: seriesOfEmployees(employeesShiftMaxByDate)
        }, 
    ];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".apexcharts-series-markers{mix-blend-mode:multiply;}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FundingRoundAndEmployeeTransitionChart_Chart, {
            options: options,
            series: series,
            width: 1060,
            height: 400
        })
    });
};
var markersOfFundingRounds = function(rounds) {
    var markers = rounds.map(function(round, i) {
        return {
            seriesIndex: 0,
            dataPointIndex: i,
            size: sizeOfRound(round),
            fillColor: colorOfRound(round.description)
        };
    });
    if (markers.length === 0) {
        return [];
    }
    // 最後のdatapointはチャートの終端を表すために配置している実データのないもののため非表示のマーカーを当てる
    var lastMarker = {
        seriesIndex: 0,
        dataPointIndex: markers.length,
        size: 0
    };
    return (0,_to_consumable_array/* default */.Z)(markers).concat([
        lastMarker
    ]);
};
var seriesOfFundingRounds = function(rounds, endDate) {
    var data = rounds.map(function(r) {
        return [
            r.date,
            r.total
        ];
    });
    if (data.length === 0) {
        return [];
    }
    var lastAmount = data[data.length - 1][1];
    var lastItem = [
        endDate,
        lastAmount
    ];
    return (0,_to_consumable_array/* default */.Z)(data).concat([
        lastItem
    ]);
};
var seriesOfEmployees = function(employeesShift) {
    return employeesShift.map(function(data) {
        var ref = (0,_sliced_to_array/* default */.Z)(data.eventDate.includes("/") ? data.eventDate.split("/") : data.eventDate.split("-"), 3), yyyy = ref[0], MM = ref[1], dd = ref[2];
        var eventDate = dd ? data.eventDate : (0,lib_date/* formatDate */.p6)((0,endOfMonth["default"])(new Date("".concat(yyyy, "/").concat(MM || "1", "/1"))).toISOString(), "yyyy/MM/dd");
        return [
            eventDate,
            data.count
        ];
    });
};
var filterMaxCountByDate = function(employeesShift) {
    return employeesShift.reduce(function(acc, current) {
        var existing = acc.find(function(item) {
            return item.eventDate === current.eventDate;
        });
        if (!existing || current.count > existing.count) {
            acc.push(current);
        }
        return acc;
    }, []);
};
var initialSeriesList = [
    "シード",
    "シリーズA",
    "シリーズB",
    "シリーズC",
    "シリーズD",
    "シリーズE",
    "シリーズF",
    "シリーズG", 
];
var annotationsOfFundingRounds = function(rounds) {
    var roudnsWithSeries = initialSeriesList.map(function(series) {
        return rounds.find(function(r) {
            return r.initialSeries === series;
        });
    }).filter(function(i) {
        return i !== undefined;
    });
    return roudnsWithSeries.map(function(r, i, arr) {
        var x2Date = arr[i + 1] ? (0,parseISO["default"])(arr[i + 1].date) : new Date();
        return {
            x: (0,parseISO["default"])(r.date).getTime(),
            x2: x2Date.getTime(),
            fillColor: colorOfInitialSeries(r.initialSeries),
            borderColor: "transparent",
            opacity: 0.7,
            label: {
                text: r.initialSeries,
                orientation: "horizontal",
                borderWidth: 0,
                offsetY: 10,
                offsetX: 30,
                style: {
                    background: "transparent",
                    fontSize: "11px"
                }
            }
        };
    });
};
var colorOfInitialSeries = function(s) {
    switch(s){
        case "シード":
            return dist/* colors.gray30 */.O9.gray30;
        case "シリーズA":
            return "#f3f0ee";
        case "シリーズB":
            return dist/* colors.cyan10 */.O9.cyan10;
        case "シリーズC":
            return "#d6ecf0";
        case "シリーズD":
            return "#b9e3ea";
        case "シリーズE":
            return dist/* colors.cyan40 */.O9.cyan40;
        case "シリーズF":
            return dist/* colors.cyan50 */.O9.cyan50;
        case "シリーズG":
            return dist/* colors.cyan60 */.O9.cyan60;
        default:
            return assertNever(s);
    }
};
var colorOfRound = function(desc) {
    switch(desc){
        case "有償第三者割当":
        case "有償株主割当":
            return "#5ed8e0";
        case "公募増資":
        case "増資":
        case "資本組み入れ":
        case "現金出資・現物出資":
        case "クラウドファンディング":
            return "#6cdf43";
        case "調達方法不明":
        case "短期借入(Loan)":
        case "長期借入(Debt)":
            return "#2dbaf0";
        case "創業":
        case "会社設立":
        case "合併（M&A,事業継承など）":
            return dist/* colors.red60 */.O9.red60;
        case "新株予約権の付与（発行）":
        case "新株引受権付社債の発行":
        case "新株予約権付社債の発行":
        case "転換社債型新株予約権付社債の発行":
        case "転換社債の発行":
        case "転換ローン(Convertible Note)の発行":
        case "転換ローン(Convertible Note)の発行 (日本版)":
        case "新株引受権の発行":
            return "#f1e95b";
        case "新株予約権の権利行使":
        case "新株引受権付社債の権利行使":
        case "新株予約権付社債の権利行使":
        case "グリーンシート":
        case "転換社債型新株予約権付社債の権利行使":
        case "転換社債の株式転換":
        case "転換ローン(Convertible Note)の株式転換":
        case "転換ローン(Convertible Note)の株式転換 (日本版)":
        case "新株引受権の権利行使":
            return "#dcd221";
        case "株式の分割":
        case "株式の移動":
            return "#ffae00";
        case "不明":
            return dist/* colors.blueGray50 */.O9.blueGray50;
        case "従業員数":
            return "#8d46b0";
        default:
            return assertNever(desc);
    }
};
var sizeOfRound = function(round) {
    switch(round.description){
        case "創業":
        case "会社設立":
            return 4;
        case "新株予約権の付与（発行）":
            return stockSize(round.increasedDilutiveShares);
        case "新株予約権の権利行使":
            return stockSize(round.increasedRealStocks);
        default:
            // "!" is aiming to fix incompatible type for the update below.
            // https://github.com/Japan-Venture-Research/penguin/pull/1176
            return amountScale(round.amount || 0);
    }
};
var stockSize = function(n) {
    if (n === null || n < 0) {
        return 3;
    }
    switch(true){
        case n < 500:
            return 4;
        case n < 1000:
            return 5;
        case n < 5000:
            return 6;
        case n < 10000:
            return 7;
        case n < 50000:
            return 8;
        case n < 100000:
            return 9;
        default:
            return 10;
    }
};
var amountScale = src_log/* default */.Z().domain([
    5000,
    1000000
]).range([
    4,
    15
]).clamp(true);
var tooltipHTMLOfFundingRounds = function(rounds, targetIndex) {
    var roundsOfTargetDate = rounds.filter(function(r) {
        var ref;
        return r.date === ((ref = rounds[targetIndex]) === null || ref === void 0 ? void 0 : ref.date);
    });
    if (roundsOfTargetDate.length === 0) {
        return null;
    }
    var date = (0,lib_date/* formatDate */.p6)(roundsOfTargetDate[0].date, "yyyy/MM/dd");
    var items = roundsOfTargetDate.map(function(r) {
        return {
            title: r.description,
            color: colorOfRound(r.description),
            dict: tooltipDictOfRound(r)
        };
    });
    return server_browser/* renderToStaticMarkup */.uS(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomTooltip, {
        date: date,
        items: items,
        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject())
    }));
};
var tooltipDictOfRound = function(round) {
    var formattedAmount = (0,number/* formatAmount */.dN)(round.amount);
    var formattedTotal = (0,number/* formatAmount */.dN)(round.total);
    switch(round.description){
        case "創業":
        case "会社設立":
            return [
                {
                    label: "調達時点総調達額",
                    value: formattedTotal ? formattedTotal.value : "",
                    unit: formattedTotal ? formattedTotal.unit : ""
                }, 
            ];
        case "有償第三者割当":
        case "クラウドファンディング":
        case "調達方法不明":
        case "有償株主割当":
        case "公募増資":
        case "増資":
        case "資本組み入れ":
        case "現金出資・現物出資":
        case "転換社債の発行":
        case "新株引受権の権利行使":
        case "合併（M&A,事業継承など）":
        case "不明":
            return [
                {
                    label: "調達額",
                    value: formattedAmount ? formattedAmount.value : "",
                    unit: formattedAmount ? formattedAmount.unit : ""
                },
                {
                    label: "調達時点総調達額",
                    value: formattedTotal ? formattedTotal.value : "",
                    unit: formattedTotal ? formattedTotal.unit : ""
                }, 
            ];
        case "短期借入(Loan)":
        case "長期借入(Debt)":
        case "転換ローン(Convertible Note)の発行":
        case "転換ローン(Convertible Note)の発行 (日本版)":
            return [
                {
                    label: "借入額",
                    value: formattedAmount ? formattedAmount.value : "",
                    unit: formattedAmount ? formattedAmount.unit : ""
                },
                {
                    label: "総額",
                    value: formattedTotal ? formattedTotal.value : "",
                    unit: formattedTotal ? formattedTotal.unit : ""
                }, 
            ];
        case "新株予約権の付与（発行）":
        case "新株引受権付社債の発行":
        case "新株予約権付社債の発行":
        case "新株引受権の発行":
        case "転換社債型新株予約権付社債の発行":
            return [
                {
                    label: "調達額",
                    value: formattedAmount ? formattedAmount.value : "",
                    unit: formattedAmount ? formattedAmount.unit : ""
                },
                {
                    label: "潜在株数",
                    value: round.increasedDilutiveShares ? "+".concat((0,number/* formatWithComma */.m$)(round.increasedDilutiveShares)) : null,
                    unit: "株"
                },
                {
                    label: "株価",
                    value: (0,number/* formatWithComma */.m$)(round.pricePerShare),
                    unit: "円"
                }, 
            ];
        case "新株予約権の権利行使":
        case "新株引受権付社債の権利行使":
        case "新株予約権付社債の権利行使":
        case "グリーンシート":
        case "転換社債型新株予約権付社債の権利行使":
        case "転換社債の株式転換":
            return [
                {
                    label: "調達額",
                    value: formattedAmount ? formattedAmount.value : "",
                    unit: formattedAmount ? formattedAmount.unit : ""
                },
                {
                    label: "実株数",
                    value: round.increasedRealStocks ? "+".concat((0,number/* formatWithComma */.m$)(round.increasedRealStocks)) : null,
                    unit: "株"
                },
                {
                    label: "株価",
                    value: (0,number/* formatWithComma */.m$)(round.pricePerShare),
                    unit: "円"
                }, 
            ];
        case "株式の分割":
            return [
                {
                    label: "分割比率",
                    value: splitRatio(round) || "不明"
                }, 
            ];
        case "株式の移動":
            return [
                {
                    label: "株価",
                    value: (0,number/* formatWithComma */.m$)(round.pricePerShare),
                    unit: "円"
                }, 
            ];
        case "転換ローン(Convertible Note)の株式転換":
        case "転換ローン(Convertible Note)の株式転換 (日本版)":
            return [];
        case "従業員数":
            return [];
        default:
            return assertNever(round.description);
    }
};
var splitRatio = function(r) {
    if (r.numberOfSharesBeforeFunding === null || r.numberOfSharesAfterFunding === null) {
        return null;
    }
    return "1:".concat(Math.round(r.numberOfSharesAfterFunding / r.numberOfSharesBeforeFunding));
};
var tooltipHTMLOfEmployees = function(employeesShift, targetIndex) {
    var employeesOfTargetDate = employeesShift[targetIndex];
    var date = (0,lib_date/* formatDate */.p6)(employeesOfTargetDate.eventDate, "yyyy/MM/dd");
    var items = [
        {
            title: "従業員数",
            color: colorOfRound("従業員数"),
            dict: [
                {
                    label: "従業員数",
                    value: employeesOfTargetDate.count,
                    unit: "人"
                },
                {
                    label: "区分",
                    value: employeesOfTargetDate.reportType,
                    unit: ""
                }, 
            ]
        }, 
    ];
    return server_browser/* renderToStaticMarkup */.uS(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomTooltip, {
        date: "".concat(date, "（").concat(employeesOfTargetDate.dateType, "）"),
        items: items,
        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject1())
    }));
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/EnterpriseBasicInfo.tsx



function EnterpriseBasicInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                display: flex;\n                margin-top: 8px;\n              "
    ]);
    EnterpriseBasicInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EnterpriseBasicInfo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  background-color: ",
        ";\n                  width: 18px;\n                  height: 18px;\n                  border-radius: 50%;\n                  margin-right: 10px;\n                  min-width: 18px;\n                "
    ]);
    EnterpriseBasicInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  font-size: 14px;\n                  line-height: 1.5;\n                "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  height: 42px;\n                  width: 115px;\n                  border: 1px solid ",
        ";\n                  display: flex;\n                  align-items: center;\n                  justify-content: center;\n                  background-color: ",
        ";\n                  font-size: 14px;\n                  line-height: 1.5;\n                  &:not(:first-of-type) {\n                    border-left: 0;\n                  }\n                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

















var EnterpriseBasicInfo = function(props) {
    var ref = (0,react.useState)(), data = ref[0], setData = ref[1];
    (0,react.useEffect)(function() {
        setData(null);
        (0,company/* fetchCompanyChart */.Q9)(props.company.shortname).then(function(result) {
            return setData(result);
        }).catch(function(e) {
            return (0,log/* printError */.O)(e);
        });
    }, [
        props.company.shortname
    ]);
    if (!isValidChartData(props.company, data)) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicFinanceInfo, {
                company: props.company,
                data: data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GrowthTransition, {
                company: props.company,
                data: data
            })
        ]
    });
};
var isValidChartData = function(company, data) {
    if (!data) {
        return false;
    }
    if ((0,lib_company/* isPrivate */.hv)(company)) {
        return !!data.privateFundraiseRatio;
    } else {
        return !!(data.ipoFundraiseRatio && data.ipoShareRatio);
    }
};
var BasicFinanceInfo = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var formattedValuation = props.company.valuation ? (0,number/* formatAmount */.dN)(props.company.valuation, {
        estimated: props.company.hasEstimatedRound
    }) : "";
    var formattedTotalFundraise = props.company.totalFundraise ? (0,number/* formatAmount */.dN)(props.company.totalFundraise, {
        estimated: props.company.hasEstimatedRound
    }) : "";
    var formattedAmount = ((ref = props.company.latestFundraise) === null || ref === void 0 ? void 0 : ref.amount) ? (0,number/* formatAmount */.dN)(props.company.latestFundraise.amount, {
        estimated: props.company.hasEstimatedRound
    }) : "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-top:1px solid ", dist/* colors.border */.O9.border, ";border-bottom:1px solid ", dist/* colors.border */.O9.border, ";"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;padding:35px 25px;justify-content:space-between;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-basis:35%;"),
                    children: [
                        (0,lib_company/* isIPO */.sH)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FinanceInfoItem, {
                            label: "IPO時 時価総額",
                            labelAnnotation: "（初値）",
                            value: (0,number/* formatWithComma */.m$)((ref1 = props.company.ipoData) === null || ref1 === void 0 ? void 0 : ref1.ipoMarketCap),
                            unit: "百万円"
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FinanceInfoItem, {
                            label: "調達後評価額",
                            labelAnnotation: "（潜在株を含む）",
                            value: formattedValuation ? formattedValuation.value : "",
                            unit: formattedValuation ? formattedValuation.unit : "",
                            valueAnnotationDesc: "算出ラウンド",
                            valueAnnotationDate: props.company.valuation && ((ref2 = props.company.financeBasicInfo) === null || ref2 === void 0 ? void 0 : ref2.lastValuationDate) ? (0,lib_date/* formatDate */.p6)(props.company.financeBasicInfo.lastValuationDate, "yyyy/MM/dd") : null
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FinanceInfoItem, {
                            label: "総調達額",
                            value: formattedTotalFundraise ? formattedTotalFundraise.value : "",
                            unit: formattedTotalFundraise ? formattedTotalFundraise.unit : "",
                            valueAnnotationDesc: "最新対象ラウンド",
                            valueAnnotationDate: props.company.totalFundraise && ((ref3 = props.company.latestFundraise) === null || ref3 === void 0 ? void 0 : ref3.date) ? (0,lib_date/* formatDate */.p6)(props.company.latestFundraise.date, "yyyy/MM/dd") : null,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:20px;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FinanceInfoItem, {
                            label: "最新ラウンド調達額",
                            value: formattedAmount ? formattedAmount.value : "",
                            unit: formattedAmount ? formattedAmount.unit : "",
                            valueAnnotationDesc: "対象ラウンド",
                            valueAnnotationDate: ((ref4 = props.company.latestFundraise) === null || ref4 === void 0 ? void 0 : ref4.date) && (0,lib_date/* formatDate */.p6)(props.company.latestFundraise.date, "yyyy/MM/dd"),
                            unknownValue: props.company.latestFundraise && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnknownValue, {}),
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:20px;")
                        })
                    ]
                }),
                (0,lib_company/* isPrivate */.hv)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:200px;"),
                    "data-testid": "fundraised-chart",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrivateFundraiseChart, {
                        data: props.data.privateFundraiseRatio
                    })
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;"),
                    "data-testid": "fundraised-chart",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IPOFundraiseChart, {
                            data: props.data.ipoFundraiseRatio,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:50px;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IPOShareChart, {
                            data: props.data.ipoShareRatio
                        })
                    ]
                })
            ]
        })
    });
};
var FinanceInfoItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:flex-start;justify-content:space-between;"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textStrong */.O9.textStrong, ";font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:14px;margin-top:5px;"),
                        children: props.label
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";font-size:13px;margin-top:5px;"),
                        children: props.labelAnnotation
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;"),
                        children: !props.value && props.unknownValue ? props.unknownValue : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                props.value || /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyNumber/* EmptyNumber */.y, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;color:", dist/* colors.textLight */.O9.textLight, ";margin-left:5px;"),
                                    children: props.unit
                                })
                            ]
                        })
                    }),
                    props.valueAnnotationDate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;color:", dist/* colors.textLight */.O9.textLight, ";margin-top:5px;"),
                        children: [
                            props.valueAnnotationDesc,
                            "：",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.textLight */.O9.textLight, ";"),
                                children: props.valueAnnotationDate
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:166px;")
                    })
                ]
            })
        ]
    });
};
var UnknownValue = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";"),
        children: "不明"
    });
};
var GrowthTransition = function(props) {
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var endDate = function() {
        if ((0,lib_company/* isIPO */.sH)(props.company) && props.company.ipoDate) {
            return (0,parseISO["default"])(props.company.ipoDate);
        }
        if ((0,lib_company/* isResearchDone */.UX)(props.company) || (0,lib_company/* isResearchUnvalued */.a5)(props.company)) {
            var ref, ref1, ref2;
            var lastEventDate = (ref = props.data.events[props.data.events.length - 1]) === null || ref === void 0 ? void 0 : ref.date;
            var lastNewsDate = (ref1 = props.data.news[props.data.news.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.date;
            var lastRoundDate = (ref2 = props.data.fundingRounds[props.data.fundingRounds.length - 1]) === null || ref2 === void 0 ? void 0 : ref2.date;
            var dates = [
                lastEventDate,
                lastNewsDate,
                lastRoundDate
            ].filter(function(d) {
                return d !== undefined;
            }).map(function(d) {
                return (0,parseISO["default"])(d);
            });
            if (dates.length > 0) {
                return (0,max["default"])(dates);
            }
        }
        return new Date();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                "data-testid": "growth-transition",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:36px 25px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:15px;line-height:1.46;", dist.mq.extraLarge, "{padding-left:30px;}"),
                            children: [
                                "成長の推移",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    onClick: function() {
                                        return setIsModalOpen(true);
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                        name: "question-circle-fill",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:15px;padding-left:3px;cursor:pointer;")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalEventsChart, {
                                    data: props.data,
                                    endDate: endDate()
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FundingRoundAndEmployeeTransitionChart, {
                                    fundingRounds: props.data.fundingRounds,
                                    employeesShift: props.company.employeesShift || [],
                                    endDate: endDate()
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GrowthTransitionModal, {
                isHidden: !isModalOpen,
                onClose: function() {
                    return setIsModalOpen(false);
                }
            })
        ]
    });
};
var GrowthTransitionModal = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:900px;.modal-content{padding:55px 50px;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalTitle, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:0;"),
                        children: "成長の推移"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: FUNDING_ROUND_TYPE_LIST.map(function(types, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: (0,emotion_react_browser_esm/* css */.iv)(EnterpriseBasicInfo_templateObject()),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(EnterpriseBasicInfo_templateObject1(), colorOfRound(types[0]))
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject2()),
                                        children: types.join("、")
                                    })
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalTitle, {
                        children: "スピーダ調達シリーズ"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            "スピーダの定義に基づいたシリーズ。定義については",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                href: "https://help.initial.inc/ja/articles/4570885-initial%E3%82%B7%E3%83%AA%E3%83%BC%E3%82%BA",
                                target: "_blank",
                                decoration: "none",
                                children: "こちら"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;margin-top:12px;"),
                                children: SERIES_LIST.map(function(s, i) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject3(), dist/* colors.black10 */.O9.black10, colorOfInitialSeries(s)),
                                        children: s
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalTitle, {
                        children: "イベント"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;line-height:1.5;"),
                        children: EVENT_TYPE_LIST.join("、")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalTitle, {
                        children: "ニュース"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;line-height:1.5;"),
                        children: NEWS_TYPE_LIST.join("、")
                    })
                ]
            })
        ]
    }));
};
var ModalTitle = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;line-height:1.5;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-top:25px;margin-bottom:5px;"),
        className: props.className,
        children: props.children
    });
};
var FUNDING_ROUND_TYPE_LIST = [
    [
        "有償第三者割当",
        "有償株主割当"
    ],
    [
        "公募増資",
        "増資",
        "資本組み入れ",
        "現金出資・現物出資",
        "クラウドファンディング", 
    ],
    [
        "調達方法不明",
        "短期借入(Loan)",
        "長期借入(Debt)"
    ],
    [
        "創業",
        "会社設立",
        "合併（M&A,事業継承など）"
    ],
    [
        "新株予約権の付与（発行）",
        "新株引受権付社債の発行",
        "新株予約権付社債の発行",
        "転換社債型新株予約権付社債の発行",
        "転換社債の発行",
        "転換ローン(Convertible Note)の発行",
        "転換ローン(Convertible Note)の発行 (日本版)",
        "新株引受権の発行", 
    ],
    [
        "新株予約権の権利行使",
        "新株引受権付社債の権利行使",
        "新株予約権付社債の権利行使",
        "グリーンシート",
        "転換社債型新株予約権付社債の権利行使",
        "転換社債の株式転換",
        "転換ローン(Convertible Note)の株式転換",
        "転換ローン(Convertible Note)の株式転換 (日本版)",
        "新株引受権の権利行使", 
    ],
    [
        "株式の分割",
        "株式の移動"
    ],
    [
        "従業員数"
    ],
    [
        "不明"
    ], 
];
var SERIES_LIST = [
    "シード",
    "シリーズA",
    "シリーズB",
    "シリーズC",
    "シリーズD",
    "シリーズE",
    "シリーズF",
    "シリーズG", 
];
var EVENT_TYPE_LIST = [
    "創業",
    "会社設立",
    "合併（M&A,事業継承など）",
    "被買収・子会社化・主要株式取得",
    "事業提携",
    "事業譲渡",
    "事業譲受",
    "破綻・清算・解散",
    "住所変更",
    "IPO", 
];
var NEWS_TYPE_LIST = [
    "ファイナンス・M&A",
    "外部ニュース", 
];

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/pages/company/molecules/GuestBasicInfo.tsx



function GuestBasicInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                display: flex;\n                margin-top: 16px;\n              "
    ]);
    GuestBasicInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GuestBasicInfo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  background-color: ",
        ";\n                  width: 18px;\n                  height: 18px;\n                  border-radius: 50%;\n                  margin-right: 10px;\n                  min-width: 18px;\n                "
    ]);
    GuestBasicInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GuestBasicInfo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  line-height: 1.4;\n                "
    ]);
    GuestBasicInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GuestBasicInfo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  height: 42px;\n                  width: 115px;\n                  border: 1px solid ",
        ";\n                  display: flex;\n                  align-items: center;\n                  justify-content: center;\n                  background-color: ",
        ";\n                  &:not(:first-of-type) {\n                    border-left: 0;\n                  }\n                "
    ]);
    GuestBasicInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















var GuestBasicInfo = function(props) {
    var ref = (0,react.useState)(), data = ref[0], setData = ref[1];
    (0,react.useEffect)(function() {
        setData(null);
        (0,company/* fetchCompanyChart */.Q9)(props.company.shortname).then(function(result) {
            return setData(result);
        }).catch(function(e) {
            return (0,log/* printError */.O)(e);
        });
    }, [
        props.company.shortname
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_BasicFinanceInfo, {
                company: props.company,
                data: data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_GrowthTransition, {})
        ]
    });
};
var GuestBasicInfo_BasicFinanceInfo = function(props) {
    var ref, ref1;
    var formattedValuation = props.company.valuation ? (0,number/* formatAmount */.dN)(props.company.valuation, {
        estimated: props.company.hasEstimatedRound
    }) : "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-top:1px solid ", dist/* colors.border */.O9.border, ";border-bottom:1px solid ", dist/* colors.border */.O9.border, ";"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;padding:35px 25px;justify-content:space-between;", dist.mq.untilMedium, "{flex-direction:column;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-basis:35%;"),
                    children: [
                        (0,lib_company/* isIPO */.sH)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_FinanceInfoItem, {
                            label: "IPO時 時価総額",
                            labelAnnotation: "（初値）",
                            value: (0,number/* formatWithComma */.m$)((ref = props.company.ipoData) === null || ref === void 0 ? void 0 : ref.ipoMarketCap),
                            unit: "百万円"
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_FinanceInfoItem, {
                            label: "調達後評価額",
                            labelAnnotation: "（潜在株を含む）",
                            value: formattedValuation ? formattedValuation.value : "",
                            unit: formattedValuation ? formattedValuation.unit : "",
                            valueAnnotationDesc: "算出ラウンド",
                            valueAnnotationDate: props.company.valuation && ((ref1 = props.company.financeBasicInfo) === null || ref1 === void 0 ? void 0 : ref1.lastValuationDate) ? (0,lib_date/* formatDate */.p6)(props.company.financeBasicInfo.lastValuationDate, "yyyy/MM/dd") : null
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_FinanceInfoItem, {
                            label: "総調達額",
                            value: "",
                            unit: "",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:20px;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_FinanceInfoItem, {
                            label: "最新ラウンド調達額",
                            value: "",
                            unit: "",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:20px;")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:200px;", dist.mq.untilMedium, "{margin-right:0;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textStrong */.O9.textStrong, ";font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:14px;"),
                                children: [
                                    "総調達額の内訳",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:12px;margin-left:4px;"),
                                        children: "（過去分含む）"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:8px;", dist.mq.untilMedium, "{text-align:center;}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "/static/images/companies/guest/startup-blur-chart1.png"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var GuestBasicInfo_FinanceInfoItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:flex-start;justify-content:space-between;"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textStrong */.O9.textStrong, ";font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:14px;margin-top:5px;"),
                        children: props.label
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";font-size:13px;margin-top:5px;"),
                        children: props.labelAnnotation
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;"),
                        children: !props.value ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            src: "/static/images/companies/guest/startup-blur-text1.png"
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                props.value || /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyNumber/* EmptyNumber */.y, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;color:", dist/* colors.textLight */.O9.textLight, ";margin-left:5px;"),
                                    children: props.unit
                                })
                            ]
                        })
                    }),
                    props.valueAnnotationDate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;color:", dist/* colors.textLight */.O9.textLight, ";margin-top:5px;"),
                        children: [
                            props.valueAnnotationDesc,
                            "：",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.textLight */.O9.textLight, ";"),
                                children: props.valueAnnotationDate
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:166px;")
                    })
                ]
            })
        ]
    });
};
var GuestBasicInfo_GrowthTransition = function() {
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:36px 25px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:15px;line-height:1.46;"),
                            children: [
                                "成長の推移",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    onClick: function() {
                                        return setIsModalOpen(true);
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                        name: "question-circle-fill",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:15px;padding-left:3px;cursor:pointer;")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:16px;display:flex;flex-direction:column;align-items:center;background:url('/static/images/companies/guest/growth-history-chart.png');background-position:center center;background-size:cover;background-repeat:no-repeat;padding:150px 0 230px;", dist.mq.untilMedium, "{display:none;}"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;max-width:480px;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;line-height:175%;letter-spacing:0.02em;color:", dist/* colors.text */.O9.text, ";"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;text-align:center;"),
                                        children: [
                                            "有料契約限定のコンテンツです。",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            "無料トライアルに申し込むと、すべてのコンテンツをご覧になれます。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: url/* trialRequestUrl */.d1,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:19px;"),
                                                children: "無料トライアルに申し込む"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        decoration: "none",
                                        href: url/* loginPath */.Qv,
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:23px;"),
                                        children: "契約済みの方はログインしてください"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;margin-block-start:16px;display:flex;flex-direction:column;align-items:center;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;line-height:175%;letter-spacing:0.02em;color:", dist/* colors.text */.O9.text, ";", dist.mq.large, "{display:none;}"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                        src: "/static/images/companies/guest/growth-history-chart-mobile.png"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:center;display:block;"),
                                        children: [
                                            "有料契約限定のコンテンツです。",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            "無料トライアルに申し込むと、すべてのコンテンツをご覧になれます。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: url/* trialRequestUrl */.d1,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            target: "_blank",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:16px;"),
                                                fullwidth: true,
                                                children: "無料トライアルに申し込む"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        decoration: "none",
                                        href: url/* loginPath */.Qv,
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:20px;"),
                                        children: "契約済みの方はログインしてください"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_GrowthTransitionModal, {
                isHidden: !isModalOpen,
                onClose: function() {
                    return setIsModalOpen(false);
                }
            })
        ]
    });
};
var GuestBasicInfo_GrowthTransitionModal = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:900px;.modal-content{padding:55px 50px;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_ModalTitle, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:0;"),
                        children: "成長の推移"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: GuestBasicInfo_FUNDING_ROUND_TYPE_LIST.map(function(types, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: (0,emotion_react_browser_esm/* css */.iv)(GuestBasicInfo_templateObject()),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(GuestBasicInfo_templateObject1(), colorOfRound(types[0]))
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(GuestBasicInfo_templateObject2()),
                                        children: types.join("、")
                                    })
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_ModalTitle, {
                        children: "スピーダ調達シリーズ"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            "スピーダの定義に基づいたシリーズ。定義については",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                href: "https://help.initial.inc/ja/articles/4570885-initial%E3%82%B7%E3%83%AA%E3%83%BC%E3%82%BA",
                                target: "_blank",
                                decoration: "none",
                                children: "こちら"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;margin-top:12px;"),
                                children: GuestBasicInfo_SERIES_LIST.map(function(s, i) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(GuestBasicInfo_templateObject3(), dist/* colors.black10 */.O9.black10, colorOfInitialSeries(s)),
                                        children: s
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_ModalTitle, {
                        children: "イベント"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: GuestBasicInfo_EVENT_TYPE_LIST.join("、")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo_ModalTitle, {
                        children: "ニュース"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("line-height:1.5;"),
                        children: GuestBasicInfo_NEWS_TYPE_LIST.join("、")
                    })
                ]
            })
        ]
    }));
};
var GuestBasicInfo_ModalTitle = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:18px;line-height:1.5;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-top:25px;margin-bottom:5px;"),
        className: props.className,
        children: props.children
    });
};
var GuestBasicInfo_FUNDING_ROUND_TYPE_LIST = [
    [
        "有償第三者割当",
        "有償株主割当"
    ],
    [
        "公募増資",
        "増資",
        "資本組み入れ",
        "現金出資・現物出資",
        "クラウドファンディング", 
    ],
    [
        "調達方法不明",
        "短期借入(Loan)",
        "長期借入(Debt)"
    ],
    [
        "創業",
        "会社設立",
        "合併（M&A,事業継承など）"
    ],
    [
        "新株予約権の付与（発行）",
        "新株引受権付社債の発行",
        "新株予約権付社債の発行",
        "転換社債型新株予約権付社債の発行",
        "転換社債の発行",
        "転換ローン(Convertible Note)の発行",
        "転換ローン(Convertible Note)の発行 (日本版)",
        "新株引受権の発行", 
    ],
    [
        "新株予約権の権利行使",
        "新株引受権付社債の権利行使",
        "新株予約権付社債の権利行使",
        "グリーンシート",
        "転換社債型新株予約権付社債の権利行使",
        "転換社債の株式転換",
        "転換ローン(Convertible Note)の株式転換",
        "転換ローン(Convertible Note)の株式転換 (日本版)",
        "新株引受権の権利行使", 
    ],
    [
        "株式の分割",
        "株式の移動"
    ],
    [
        "不明"
    ], 
];
var GuestBasicInfo_SERIES_LIST = [
    "シード",
    "シリーズA",
    "シリーズB",
    "シリーズC",
    "シリーズD",
    "シリーズE",
    "シリーズF",
    "シリーズG", 
];
var GuestBasicInfo_EVENT_TYPE_LIST = [
    "創業",
    "会社設立",
    "合併（M&A,事業継承など）",
    "被買収・子会社化・主要株式取得",
    "事業提携",
    "事業譲渡",
    "事業譲受",
    "破綻・清算・解散",
    "住所変更",
    "IPO", 
];
var GuestBasicInfo_NEWS_TYPE_LIST = [
    "ファイナンス・M&A",
    "外部ニュース", 
];

;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyBasicInfo.tsx



















var CompanyBasicInfo = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                    href: "https://help.initial.inc/ja/articles/5732414"
                }),
                sub: (0,lib_company/* isResearchContinue */.hD)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                children: props.company.basicInfoUpdatedAt
                            })
                        }),
                        "更新"
                    ]
                }) : "",
                children: "企業概要"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                className: "overview",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DoubleColumnContent/* DoubleColumnContent */.D, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                企業名: {
                                    text: props.company.name
                                },
                                英語名: {
                                    text: props.company.englishName
                                },
                                代表者名: {
                                    text: props.company.representative
                                },
                                住所: {
                                    text: props.company.address
                                }
                            }, (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && {
                                電話番号: {
                                    text: props.company.telephone
                                }
                            }), {
                                URL: {
                                    text: props.company.website && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        href: props.company.website,
                                        target: "_blank",
                                        rel: "noopener",
                                        decoration: "none",
                                        children: props.company.website
                                    })
                                },
                                設立: {
                                    text: props.company.establishedAt && (0,lib_date/* formatDate */.p6)(props.company.establishedAt, "yyyy/MM")
                                }
                            }), props.company.origin && {
                                起源: {
                                    text: props.company.origin
                                }
                            }, props.company.university && {
                                "大学発（大学名）": {
                                    text: props.company.university
                                }
                            }, props.company.registeredAddress && {
                                本店登記所在地: {
                                    text: props.company.registeredAddress
                                }
                            }, props.company.parentCompany && {
                                親会社: {
                                    text: props.company.parentCompany.name
                                }
                            })
                        }),
                        (0,lib_company/* isPrivate */.hv)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: {
                                タイプ: {
                                    text: props.company.recordType
                                },
                                業種: {
                                    text: props.company.industry
                                },
                                株主状況: {
                                    text: props.company.shareholderStatus
                                },
                                smartround: {
                                    text: props.smartroundUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        href: props.smartroundUrl,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        decoration: "none",
                                        children: props.smartroundUrl
                                    }) : null,
                                    extraClassName: "smartround-url",
                                    help: "smartroundについて",
                                    helpLink: "https://help.initial.inc/ja/articles/6384970",
                                    isHidden: props.smartroundUrl == null
                                },
                                SNS: {
                                    text: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SNSLinks/* SNSLinks */.s, {
                                        facebook: props.company.facebookUrl,
                                        twitter: props.company.twitterUrl,
                                        color: dist/* colors.black10 */.O9.black10,
                                        iconSize: 20
                                    })
                                }
                            }
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: {
                                タイプ: {
                                    text: props.company.recordType
                                },
                                業種: {
                                    text: props.company.industry
                                },
                                IPO区分: {
                                    text: props.company.ipoCategory
                                },
                                IPO年月日: {
                                    text: props.company.ipoDate && (0,lib_date/* formatDate */.p6)(props.company.ipoDate, "yyyy/MM/dd")
                                },
                                IPO市場: {
                                    text: props.company.market
                                },
                                市場の移動: {
                                    text: props.company.marketMovement
                                },
                                証券コード: {
                                    text: props.company.tickerSymbol
                                },
                                SNS: {
                                    text: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SNSLinks/* SNSLinks */.s, {
                                        facebook: props.company.facebookUrl,
                                        twitter: props.company.twitterUrl,
                                        color: dist/* colors.black10 */.O9.black10,
                                        iconSize: 20
                                    })
                                }
                            }
                        })
                    ]
                })
            }),
            (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnterpriseBasicInfo, {
                company: props.company
            }),
            (0,lib_user/* isGuest */.nJ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestBasicInfo, {
                company: props.company
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(24762);
// EXTERNAL MODULE: ./components/common/OpenCloseToggle.tsx
var OpenCloseToggle = __webpack_require__(63043);
// EXTERNAL MODULE: ./lib/collection.ts
var collection = __webpack_require__(67064);
// EXTERNAL MODULE: ./components/atoms/LineClampText.tsx
var LineClampText = __webpack_require__(89277);
;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyFundingRounds.tsx


function CompanyFundingRounds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    background-color: ",
        ";\n                  "
    ]);
    CompanyFundingRounds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyFundingRounds_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      text-align: center;\n                      padding-top: 0.9rem;\n                      padding-bottom: 0.7rem;\n                      padding-left: 0rem;\n                      padding-right: 0rem;\n                      min-width: 50px;\n                    "
    ]);
    CompanyFundingRounds_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyFundingRounds_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      padding-left: 0.2rem;\n                    "
    ]);
    CompanyFundingRounds_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyFundingRounds_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        padding: 0;\n                      "
    ]);
    CompanyFundingRounds_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                td {\n                  border-bottom-width: ",
        ";\n                }\n              "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  padding-left: 18px !important;\n                "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}















var CompanyFundingRounds = function(props) {
    var ref = (0,react.useState)([]), openingShortnames = ref[0], setOpeningShortnames = ref[1];
    var roundWithDetailsShortnames = props.list.filter(function(fr) {
        return fr.roundDetails && fr.roundDetails.length > 0;
    }).map(function(fr) {
        return fr.shortname;
    });
    var hasRoundWithDetails = roundWithDetailsShortnames.length !== 0;
    var toggleRoundDetails = function(shortname) {
        if (isRoundOpen(shortname)) {
            setOpeningShortnames(openingShortnames.filter(function(s) {
                return s !== shortname;
            }));
        } else {
            setOpeningShortnames((0,_to_consumable_array/* default */.Z)(openingShortnames).concat([
                shortname
            ]));
        }
    };
    var toggleAllRoundDetails = function() {
        if (isAllRoundsOpen) {
            setOpeningShortnames([]);
            index_es/* default.hide */.Z.hide();
        } else {
            setOpeningShortnames(roundWithDetailsShortnames);
            index_es/* default.hide */.Z.hide();
        }
    };
    var isRoundOpen = function(shortname) {
        return openingShortnames.includes(shortname);
    };
    var isAllRoundsOpen = hasRoundWithDetails && (0,collection/* equal */.Dg)(roundWithDetailsShortnames, openingShortnames);
    var buttonLabel = !hasRoundWithDetails ? "" : isAllRoundsOpen ? "すべて閉じる" : "すべて開く";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "ラウンド情報"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHead */.ss, {
                        sticky: true,
                        offset: "112px",
                        dataTestId: "funding-rounds-table-header",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                                        label: buttonLabel,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpenCloseToggle/* OpenCloseToggle */.m, {
                                            status: isAllRoundsOpen ? "open" : hasRoundWithDetails ? "closed" : "disabled",
                                            onClick: toggleAllRoundDetails,
                                            isLarge: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-left:0.2rem !important;"),
                                    children: "ラウンド行"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "年月日"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "種別"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                    help: "スピーダが独自に定義する成長フェーズ",
                                    align: "center",
                                    helpProps: {
                                        linkTo: "https://help.initial.inc/ja/articles/4570885-initial%E3%82%B7%E3%83%AA%E3%83%BC%E3%82%BA"
                                    },
                                    children: [
                                        "スピーダ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                        "調達シリーズ"
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    sub: "円",
                                    children: "株価"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    sub: "千円",
                                    children: "調達金額"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    sub: "千円",
                                    children: "調達後評価額"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "備考"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.list.map(function(fr, i) {
                            var roundDetails = fr.roundDetails || [];
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                        id: fr.shortname,
                                        css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFundingRounds_templateObject(), fr.initialSeries ? dist/* colors.cyan10 */.O9.cyan10 : dist/* colors.white00 */.O9.white00),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFundingRounds_templateObject1()),
                                                className: "expand-toggle",
                                                children: roundDetails.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpenCloseToggle/* OpenCloseToggle */.m, {
                                                    status: isRoundOpen(fr.shortname) ? "open" : "closed",
                                                    onClick: function() {
                                                        return toggleRoundDetails(fr.shortname);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                nowrap: true,
                                                css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFundingRounds_templateObject2()),
                                                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                    href: fr.path,
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    decoration: "none",
                                                    children: fr.shortname
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                nowrap: true,
                                                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                children: fr.date && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                    children: fr.date
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                nowrap: true,
                                                children: fr.description
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: fr.initialSeries
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                align: "right",
                                                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                children: (0,number/* formatWithComma */.m$)(fr.pricePerShare, {
                                                    decimalPlace: 1
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                align: "right",
                                                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                children: (0,number/* formatWithComma */.m$)(fr.amount)
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EstimatedCell, {
                                                estimated: fr.estimated
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                align: "right",
                                                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                children: (0,number/* formatWithComma */.m$)(fr.postMoney)
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                                                    lineNumber: 1,
                                                    children: fr.remarks
                                                })
                                            })
                                        ]
                                    }),
                                    roundDetails.length > 0 && isRoundOpen(fr.shortname) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                            colSpan: 10,
                                            css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFundingRounds_templateObject3()),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoundDetailTable, {
                                                    list: roundDetails
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, "".concat(i, "-").concat(fr.shortname));
                        })
                    })
                ]
            })
        ]
    });
};
var RoundDetailTable = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-left:30px;background-color:", dist/* colors.white10 */.O9.white10, ";th{background-color:", dist/* colors.white10 */.O9.white10, ";}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("th{top:100px;font-size:12px;color:", dist/* colors.textLight */.O9.textLight, ";}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:15%;padding-left:22px !important;"),
                            children: "ラウンド行"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:15%;"),
                            children: "投資家名"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:15%;"),
                            children: "株式種類"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:15%;"),
                            children: [
                                "投資額(千円)",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:40%;"),
                            children: "備考"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                children: props.list.map(function(rd, i) {
                    var isLast = props.list.length === i + 1;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject4(), isLast ? 0 : "1px"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableCell */.pj, {
                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject5()),
                                className: "".concat(wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y, " round-shortname"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LowerLeftIcon, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        href: rd.path,
                                        target: "_blank",
                                        rel: "noopener",
                                        decoration: "none",
                                        children: rd.shortname
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                className: "investor-name",
                                children: rd.gpInvestors && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                    href: rd.gpInvestors[0].path,
                                    decoration: "none",
                                    target: "_blank",
                                    rel: "noopener",
                                    children: rd.gpInvestors[0].name
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: rd.typeOfStock
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                align: "right",
                                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                children: (0,number/* formatWithComma */.m$)(rd.amount)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EstimatedCell, {
                                estimated: rd.estimated
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                                    lineNumber: 2,
                                    children: rd.remarks
                                })
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
var LowerLeftIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-right:5px;padding-left:3px;"),
        name: "box-drawing-character"
    });
};
var EstimatedCell = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";font-size:80%;padding-left:0;"),
        nowrap: true,
        children: props.estimated && "(推測)"
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/DirectorsTable.tsx










var DirectorsTable = function(props) {
    if (!props.isEnterprise) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                    title: props.title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:", props.isEnterprise ? "initial" : "none", ";}"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                        children: "名前"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                        children: "役職"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                        children: "職名"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                        children: "略歴"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                        children: "出所"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:flex;justify-content:center;}"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    colSpan: 5,
                                    align: "center",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LimitedToEnterpriseContents, {})
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
    if (props.directors.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: props.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "名前"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "役職"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "職名"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "略歴"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "出所"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.directors.map(function(d, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        nowrap: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                            href: d.path,
                                            decoration: "none",
                                            children: d.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        nowrap: true,
                                        children: d.title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        nowrap: true,
                                        children: d.jobTitle
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                                            lineNumber: 3,
                                            children: d.bio
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        nowrap: true,
                                        children: d.sourceSite
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/PartnershipsTable.tsx










var PartnershipsTable = function(props) {
    if (!props.isEnterprise) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:", props.isEnterprise ? "initial" : "none", ";}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "提携日"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "事業提携先"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                children: [
                                    "種別",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                        children: "投資家の種別 (VC、海外VC、事業法人、金融機関など)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "属性"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:flex;justify-content:center;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                            colSpan: 4,
                            align: "center",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LimitedToEnterpriseContents, {})
                        })
                    })
                })
            ]
        });
    }
    if (props.partnerships.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "提携日"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "事業提携先"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                            children: [
                                "種別",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                    children: "投資家の種別 (VC、海外VC、事業法人、金融機関など)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "属性"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                children: props.partnerships.map(function(p, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                className: "partnership-date",
                                children: p.roundDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                    children: p.roundDate
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                    decoration: "none",
                                    href: p.investor.path,
                                    target: "_blank",
                                    rel: "noopner",
                                    children: p.investor.name
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: p.investor.category
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: p.investor.subCategory
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/roundtype.ts
var roundtype = __webpack_require__(39250);
// EXTERNAL MODULE: ./components/atoms/icons/IPOIcon.tsx
var IPOIcon = __webpack_require__(86996);
// EXTERNAL MODULE: ./components/atoms/table/TotalFundraiseValues.tsx
var TotalFundraiseValues = __webpack_require__(95205);
// EXTERNAL MODULE: ./components/atoms/TagButton.tsx
var TagButton = __webpack_require__(15071);
;// CONCATENATED MODULE: ./components/atoms/LoadingSpinner.tsx


var LoadingSpinner = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;.loader,.loader:after{border-radius:50%;width:10em;height:10em;}.loader{margin:24px auto;font-size:", size, "px;position:relative;text-indent:-9999em;border-top:1.1em solid rgba(0,0,0,0.2);border-right:1.1em solid rgba(0,0,0,0.2);border-bottom:1.1em solid rgba(0,0,0,0.2);border-left:1.1em solid #ffffff;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation:load8 1.1s infinite linear;animation:load8 1.1s infinite linear;}@-webkit-keyframes load8{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}}@keyframes load8{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "loader"
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverseaBenchmarkMappingTable.tsx

function OverseaBenchmarkMappingTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      display: flex;\n                    "
    ]);
    OverseaBenchmarkMappingTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OverseaBenchmarkMappingTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        margin-left: 10px;\n                        flex: 1;\n                      "
    ]);
    OverseaBenchmarkMappingTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OverseaBenchmarkMappingTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                          display: flex;\n                        "
    ]);
    OverseaBenchmarkMappingTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OverseaBenchmarkMappingTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                                font-size: 15px;\n                              "
    ]);
    OverseaBenchmarkMappingTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OverseaBenchmarkMappingTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                              margin-left: 3px;\n                            "
    ]);
    OverseaBenchmarkMappingTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function OverseaBenchmarkMappingTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                          font-size: 12px;\n                          line-height: 1.5;\n                        "
    ]);
    OverseaBenchmarkMappingTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                          margin-top: 6px;\n                        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                              color: #999;\n                              font-size: 11px;\n                            "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




















var OverseaBenchmarkMappingTable = function(props) {
    var ref = (0,react.useState)([]), overseaBenchmarkCompanies = ref[0], setOverseaBenchmarkCompanies = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        setIsLoading(true);
        setOverseaBenchmarkCompanies([]);
        (0,company/* fetchOverseaBenchmarkCompanies */.ih)(props.shortname).then(function(res) {
            setOverseaBenchmarkCompanies(res.overseaBenchmarkCompanies);
            setIsLoading(false);
        });
    }, [
        props.shortname
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        "data-test-id": "oversea-benchmark",
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "海外スタートアップ"
            }),
            isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingSpinner, {
                size: 3
            }) : overseaBenchmarkCompanies.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                className: "oversea-benchmark-companies",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHead */.ss, {
                        className: "header",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> th{background-color:", dist/* colors.white10 */.O9.white10, " !important;}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    className: "company-name",
                                    children: "企業名"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    className: "country-name",
                                    children: "国・地域"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    className: "last-funding-on",
                                    align: "center",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                children: "最新ラウンド"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                children: "調達日"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                    className: "last-funding-type",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    children: "最新ラウンド"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    children: "タイプ"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                            className: "help",
                                            linkTo: "https://help.initial.inc/ja/articles/5489432",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("vertical-align:bottom;"),
                                            children: "定義を見る"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    className: "total-fundraise",
                                    align: "center",
                                    children: "総調達額"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    className: "valuation",
                                    align: "center",
                                    children: "調達後評価額"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: overseaBenchmarkCompanies.map(function(company, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableRow */.SC, {
                                highlightOnHover: true,
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        width: "50%",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: (0,emotion_react_browser_esm/* css */.iv)(OverseaBenchmarkMappingTable_templateObject()),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    as: "/companies/".concat(company.globalId),
                                                    href: url/* COMPANY_HREF */.bP,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                                            className: "company-logo",
                                                            src: company.logoUrl || (0,lib_company/* companyDefaultImage */.tP)(company.listed ? "IPO企業" : "未公開企業"),
                                                            size: "normal",
                                                            name: company.name
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: (0,emotion_react_browser_esm/* css */.iv)(OverseaBenchmarkMappingTable_templateObject1()),
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(OverseaBenchmarkMappingTable_templateObject2()),
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    className: "company-name",
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                        as: "/companies/".concat(company.globalId),
                                                                        href: url/* COMPANY_HREF */.bP,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                                            decoration: "none",
                                                                            css: (0,emotion_react_browser_esm/* css */.iv)(OverseaBenchmarkMappingTable_templateObject3()),
                                                                            children: company.name
                                                                        })
                                                                    })
                                                                }),
                                                                company.listed && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IPOIcon/* IPOIcon */.K, {
                                                                    isHiddenTooltip: true,
                                                                    className: "ipo-label",
                                                                    css: (0,emotion_react_browser_esm/* css */.iv)(OverseaBenchmarkMappingTable_templateObject4())
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                                                            justify: true,
                                                            lineNumber: 5,
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(OverseaBenchmarkMappingTable_templateObject5()),
                                                            stripLineBreaks: true,
                                                            className: "description",
                                                            children: company.description
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject6()),
                                                            children: company.tags && company.tags.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButtonGroup */.U, {
                                                                className: "tags",
                                                                children: company.tags.map(function(tag, i) {
                                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                                                                        tag: tag
                                                                    }, i);
                                                                })
                                                            }) : null
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        nowrap: true,
                                        align: "left",
                                        vertical: "middle",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "country-name",
                                            children: company.country
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        className: "last-funding-on",
                                        children: company.totalFundraise && company.totalFundraise.date ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                children: company.totalFundraise.date
                                            })
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "last-funding-type",
                                            children: company.lastFundingType && (0,roundtype/* formatLastFundingType */.e)(company.lastFundingType)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        align: "right",
                                        width: "10%",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "total-fundraise",
                                            children: company.totalFundraise && company.totalFundraise.value !== null && company.totalFundraise.value !== 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TotalFundraiseValues/* TotalFundraiseValues */.E, {
                                                currency: company.totalFundraise.currency,
                                                value: company.totalFundraise.value
                                            }) : null
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        align: "right",
                                        width: "10%",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "valuation",
                                            children: company.valuation && company.valuation !== null && company.valuation.value !== 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TotalFundraiseValues/* TotalFundraiseValues */.E, {
                                                        currency: company.valuation.currency,
                                                        value: company.valuation.value
                                                    }),
                                                    company.listed && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        className: "pre-ipo-valuation",
                                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject7()),
                                                        children: "IPO前最終調達時"
                                                    })
                                                ]
                                            }) : null
                                        })
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {
                children: "データ未作成です"
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/company/molecules/domestic/CompanyInviewForActiveTab.tsx
var CompanyInviewForActiveTab = __webpack_require__(82263);
;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyIPOData.tsx


function CompanyIPOData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    margin-bottom: 0.3rem;\n                  "
    ]);
    CompanyIPOData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var CompanyIPOData = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IPOList, {
                ipoData: props.ipoData
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreIPOList, {
                preIPOData: props.preIPOData
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IPOShareholdersTable, {
                ipoShareholders: props.ipoShareholders
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomLinkList, {
                customLink: props.customLink
            })
        ]
    });
};
var IPOList = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "IPO時データ"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DoubleColumnContent/* DoubleColumnContent */.D, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("dt,dd{flex:1;}"),
                        list: {
                            初値: {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.initialPrice)
                            },
                            公募価格: {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.publicOfferingPrice)
                            },
                            初値の騰落率: {
                                text: inPercentage(props.ipoData.initialPriceRiseFallRate)
                            },
                            "IPO時 資金調達金額: 公募(百万円)": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.ipoFundraising, {
                                    decimalPlace: 1
                                }),
                                help: "IPO時の公募による資金調達の総額"
                            },
                            "IPO時 時価総額(初値)(百万円)": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.ipoMarketCap, {
                                    decimalPlace: 1
                                }),
                                help: "IPO時の初値\xd7発行済株式数（※潜在株は含まない）"
                            },
                            初値PER: {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.per, {
                                    decimalPlace: 2
                                })
                            },
                            "IPO日前 株数": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.numberOfSharesBeforeIpo)
                            },
                            "IPO日 株数": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.numberOfSharesAtIpo)
                            },
                            "IPOまでの年数(年)": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.yearsToIpo, {
                                    decimalPlace: 2
                                })
                            },
                            "IPO企業 社長名": {
                                text: props.ipoData.ipoRepresentative
                            },
                            社長生年月日: {
                                text: props.ipoData.representativeBirthday
                            },
                            社長年齢: {
                                text: props.ipoData.representativeAge
                            },
                            "IPO前期 売上: 単体(百万円)": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.previousTermSalesNonConsolidated, {
                                    decimalPlace: 1
                                }),
                                help: "IPO直前期の売上"
                            },
                            "IPO前期 売上: 連結(百万円)": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.previousTermSalesConsolidated, {
                                    decimalPlace: 1
                                }),
                                help: "IPO直前期の売上"
                            },
                            "IPO前期 純利益: 単体(百万円)": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.previousTermNetIncomeNonConsolidated, {
                                    decimalPlace: 1
                                }),
                                help: "IPO直前期の純利益"
                            },
                            "IPO前期 純利益: 連結(百万円)": {
                                text: (0,number/* formatWithComma */.m$)(props.ipoData.previousTermNetIncomeConsolidated, {
                                    decimalPlace: 1
                                }),
                                help: "IPO直前期の純利益"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("dt,dd{flex:1;}"),
                        list: {
                            主幹事: {
                                text: props.ipoData.leadScretary
                            },
                            監査法人: {
                                text: props.ipoData.auditFirm
                            },
                            ロックアップ期間: {
                                text: props.ipoData.lockupPeriod
                            },
                            ラウンド数: {
                                text: props.ipoData.numberOfRounds
                            },
                            VC数: {
                                text: props.ipoData.numberOfVCs
                            },
                            VC比率: {
                                text: inPercentage(props.ipoData.vcPercentage)
                            },
                            "事業会社 比率": {
                                text: inPercentage(props.ipoData.cvcPercentage)
                            },
                            "個人 比率": {
                                text: inPercentage(props.ipoData.angelPercentage)
                            },
                            "潜在株 比率": {
                                text: inPercentage(props.ipoData.dilutiveSharesPercentage)
                            },
                            "社員 持株会": {
                                text: inPercentage(props.ipoData.employeeShareholdingAssociation),
                                help: "従業員持株会の株式総数に対する\n所有株式数の割合(潜在株を含む)"
                            },
                            "リード（トップ）VC": {
                                text: props.ipoData.leadVC && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: url/* INVESTOR_HREF */.JM,
                                    as: props.ipoData.leadVC.path,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        decoration: "none",
                                        children: props.ipoData.leadVC.name
                                    })
                                })
                            },
                            シェア: {
                                text: inPercentage(props.ipoData.leadVCShare)
                            },
                            "VC 比率：備考": {
                                text: props.ipoData.vcRemarks
                            },
                            "創業者 個人所有": {
                                text: inPercentage(props.ipoData.founderPersonalShareHoldingRate),
                                help: "創業者(個人名)の株式総数に対する\n所有株式数の割合(潜在株を含む)"
                            },
                            "創業者 一族所有": {
                                text: inPercentage(props.ipoData.founderFamilyShareHoldingRate),
                                help: "創業者、創業者の配偶者および二親等内の\n株式総数に対する所有株式数の割合(潜在株を含む)"
                            },
                            "創業者 持株会社": {
                                text: inPercentage(props.ipoData.founderCompanyHoldingRate),
                                help: "創業者の持株会社(財産保全会社)の株式総数に対する\n所有株式数の割合(潜在株を含む)"
                            },
                            創業者持株比率の備考: {
                                text: props.ipoData.founderHoldingRateRemarks
                            }
                        }
                    })
                ]
            })
        ]
    });
};
var PreIPOList = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:30px;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "PreIPOサマリー情報"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DoubleColumnContent/* DoubleColumnContent */.D, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("dt,dd{flex:1;}"),
                        list: {
                            "投資総額(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoFunding),
                                help: "設立からIPOまでに調達した資金のグロス総額 (資本金+資本準備金+減資額)"
                            },
                            "投資総額VC(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoVCFunding),
                                help: "投資総額の内訳、VB企業の資金となったVC投資額、移動などは含まない",
                                indent: true
                            },
                            "投資総額 事業会社(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoCVCFunding),
                                indent: true
                            },
                            "投資総額個人(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoAngelFunding),
                                indent: true
                            },
                            "投資のべ総額(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoGrossInvestment),
                                help: "設立からIPOまでに投資された総額 (既存株主からの株式の取得を含む)"
                            },
                            "投資のべ総額VC(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoVCGrossInvestment),
                                help: "既存株主からの株式の取得を含む投資家の投資総額",
                                indent: true
                            },
                            "投資のべ総額 事業会社(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoCVCGrossInvestment),
                                indent: true
                            },
                            "投資のべ総額個人(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoAngelGrossInvestment),
                                indent: true
                            },
                            "IPO直近 時価総額(百万円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.preIpoPostMoney),
                                help: "IPO直前の第三者割当増資のラウンドまたは株主移動におけるPostMoney"
                            },
                            サマリー備考: {
                                text: props.preIPOData.summaryRemarks
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("dt,dd{flex:1;}dt{white-space:nowrap;}dd{padding-left:12px;}"),
                        list: {
                            "短期借入金(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.shortDebt),
                                help: "IPO直前(四半期ベース)の短期借入金"
                            },
                            "短期借入金の合計(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.shortDebtTotal),
                                help: "IPO直前(四半期ベース)の短期借入金、\n１年以内返済予定の長期借入金、\n１年以内償還予定の社債の合計",
                                indent: true
                            },
                            "１年以内償還予定の社債(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.returnableCorportateBond),
                                help: "IPO直前(四半期ベース)の１年以内償還予定の社債",
                                indent: true
                            },
                            "１年以内返済予定の長期借入金(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.returnableLongDebt),
                                help: "IPO直前(四半期ベース)の１年以内返済予定の長期借入金",
                                indent: true
                            },
                            "長期借入金(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.longDebt),
                                help: "IPO直前(四半期ベース)の長期借入金"
                            },
                            "社債(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.corporateBond),
                                help: "IPO直前(四半期ベース)の社債",
                                indent: true
                            },
                            "長期借入金の合計(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.longDebtTotal),
                                help: "IPO直前(四半期ベース)の長期借入金の合計",
                                indent: true
                            },
                            "短期および長期借入金の合計(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.debtTotal),
                                help: "IPO直前(四半期ベース)の短期および長期借入金の合計"
                            },
                            "株主資本合計(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.shareholdersEquity)
                            },
                            "純資産合計(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.assetValue)
                            },
                            "負債純資産合計(千円)": {
                                text: (0,number/* formatWithComma */.m$)(props.preIPOData.totalLiabilitiesAndNetAssets)
                            }
                        }
                    })
                ]
            })
        ]
    });
};
var IPOShareholdersTable = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:30px;"),
        id: "shareholders",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "株主サマリー (IPO時)"
            }),
            props.ipoShareholders.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "投資家名"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                    children: [
                                        "IPO直前株数",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                            children: "IPO直前の所有株数(潜在株を含む)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                    children: [
                                        "シェア",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                            children: "IPO直前の所有株式(潜在株式を含む)の割合%"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                    children: [
                                        "投資金額合計",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* SubLabel */.vQ, {
                                            children: "千円"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                            children: "IPOまでに投資した金額(株式を譲受した場合は取得額を\n投資額に加算、譲渡した場合は売却額を投資額から減額)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                    children: [
                                        "平均株価",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* SubLabel */.vQ, {
                                            children: "円"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                            children: "投資金額合計(株式を譲受した場合は取得額を投資額に加算、\n譲渡した場合は売却額を投資額から減額)\xf7全株数"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "備考"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.ipoShareholders.map(function(s, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                            href: s.investor.path,
                                            decoration: "none",
                                            children: s.investor.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        align: "right",
                                        children: (0,number/* formatWithComma */.m$)(s.numberOfSharesBeforeIpo, {
                                            decimalPlace: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        align: "right",
                                        children: inPercentage(s.share, {
                                            decimalPlace: 3
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        align: "right",
                                        children: (0,number/* formatWithComma */.m$)(s.totalInvestment)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        align: "right",
                                        children: (0,number/* formatWithComma */.m$)(s.stockAverage, {
                                            decimalPlace: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: s.remarks
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {
                children: "データ未作成です"
            })
        ]
    });
};
var CustomLinkList = function(props) {
    var links = Object.entries(props.customLink).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _k = _param[0], url = _param[1];
        return url !== null;
    });
    if (links.length === 0) {
        return null;
    }
    var leftLinks = links.slice(0, 3);
    var rightLinks = links.slice(3, 6);
    var linkLabels = {
        tokyoIpo: "東京IPO",
        tradersWeb: "Trader's WEB",
        irData: "IRデータ（KCR総研）",
        yahooKessan: "連結決算推移",
        yahooCorp: "Yahoo企業概要",
        nikkeiNet: "日経Net"
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:30px;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "カスタムリンク"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card.Content */.Zb.Content, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Column.Group */.sg.Group, {
                    children: [
                        leftLinks,
                        rightLinks
                    ].map(function(links, i) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Column */.sg, {
                            children: links.map(function(param, i) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], url = _param[1];
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: (0,emotion_react_browser_esm/* css */.iv)(CompanyIPOData_templateObject()),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener",
                                        decoration: "none",
                                        children: linkLabels[k]
                                    })
                                }, i);
                            })
                        }, i);
                    })
                })
            })
        ]
    });
};
var inPercentage = function(n, options) {
    var ref;
    var decimalPlace = (ref = options === null || options === void 0 ? void 0 : options.decimalPlace) !== null && ref !== void 0 ? ref : 2;
    return n ? "".concat((0,number/* formatWithComma */.m$)(n, {
        decimalPlace: decimalPlace
    }), "%") : "";
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyFinanceNewsList.tsx

function CompanyFinanceNewsList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                padding: 15px 20px;\n                border-bottom: 1px solid ",
        ";\n                ",
        " {\n                  display: flex;\n                }\n              "
    ]);
    CompanyFinanceNewsList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyFinanceNewsList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  display: flex;\n                  align-items: center;\n                  white-space: nowrap;\n                  ",
        " {\n                    flex-basis: 160px;\n                  }\n                "
    ]);
    CompanyFinanceNewsList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyFinanceNewsList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    font-size: 14px;\n                    letter-spacing: 0.8px;\n                    font-weight: ",
        ";\n                    color: ",
        ";\n                    margin-right: 10px;\n                  "
    ]);
    CompanyFinanceNewsList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyFinanceNewsList_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    font-size: 14px;\n                    color: ",
        ";\n                  "
    ]);
    CompanyFinanceNewsList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyFinanceNewsList_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  font-size: 14px;\n                  font-weight: ",
        ";\n                  line-height: 1.4;\n                  margin-top: 5px;\n                  ",
        " {\n                    flex: 1;\n                  }\n                "
    ]);
    CompanyFinanceNewsList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompanyFinanceNewsList_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    color: ",
        ";\n                    transition: 0.3s;\n                    &:hover {\n                      text-decoration: underline;\n                    }\n                  "
    ]);
    CompanyFinanceNewsList_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











var CompanyFinanceNewsList = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "資金調達・提携ニュース"
            }),
            props.financeNews.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {}) : props.financeNews.map(function(news, i) {
                var path = (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) ? news.path : news.externalUrl;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFinanceNewsList_templateObject(), dist/* colors.gray50 */.O9.gray50, dist.mq.large),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFinanceNewsList_templateObject1(), dist.mq.large),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFinanceNewsList_templateObject2(), dist/* font.weight.bold */.LZ.weight.bold, dist/* colors.textLight */.O9.textLight),
                                    children: news.category
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFinanceNewsList_templateObject3(), dist/* colors.textLight */.O9.textLight),
                                    className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                        children: news.publishedAt
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFinanceNewsList_templateObject4(), dist/* font.weight.bold */.LZ.weight.bold, dist.mq.large),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                href: path,
                                target: "_blank",
                                rel: "noopener",
                                decoration: "none",
                                css: (0,emotion_react_browser_esm/* css */.iv)(CompanyFinanceNewsList_templateObject5(), dist/* colors.black30 */.O9.black30),
                                children: news.title
                            })
                        })
                    ]
                }, i);
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/common/npStartup/NewsPicksSearchResult.tsx
var NewsPicksSearchResult = __webpack_require__(45270);
// EXTERNAL MODULE: ./lib/api/np/feed.ts + 1 modules
var feed = __webpack_require__(13173);
;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyNewsPicksFeeds.tsx











var CompanyNewsPicksFeeds = function(props) {
    var ref = (0,react.useState)(null), npFeeds = ref[0], setNpFeeds = ref[1];
    (0,react.useEffect)(function() {
        setNpFeeds(null);
        (0,feed/* fetchNPFeedsByCompanyShortname */.gx)(props.shortname).then(function(r) {
            setNpFeeds(r);
        }).catch(function(e) {
            return (0,log/* printError */.O)(e);
        });
    }, [
        props.shortname
    ]);
    var className = props.className ? [
        props.className,
        "np-feeds"
    ].join(" ") : "np-feeds";
    if (!npFeeds) return null;
    var newsPicksFeeds = npFeeds.slice(0, 10);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: className,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                    title: "NewsPicksの検索結果",
                    helpText: "検索結果について",
                    helpLink: "https://help.initial.inc/ja/articles/5676034"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("& >:not(:last-child){border-bottom:1px solid ", dist/* colors.gray50 */.O9.gray50, ";}"),
                    children: npFeeds.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {}) : newsPicksFeeds.map(function(feed, i) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksSearchResult/* NewsPicksFeedSearchResultItem */.SH, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            index: i + 1
                        }, feed), {
                            classPrefix: "companypage"
                        }), i);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(27322);
;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyNewsFeed.tsx











var CompanyNewsFeed = function(props) {
    var ref = (0,react.useRef)(null);
    var _feed;
    var ref1 = (0,react.useState)({
        data: (_feed = props.feed) !== null && _feed !== void 0 ? _feed : [],
        count: 0
    }), feed = ref1[0], setFeed = ref1[1];
    var ref2 = (0,react.useState)(1), page = ref2[0], setPage = ref2[1];
    var loadCompanyNewsFeed = function(page) {
        var offset = (page - 1) * 10;
        return (0,company/* fetchCompanyNewsFeed */.gQ)(props.shortname, {
            offset: offset
        }).then(function(f) {
            return setFeed(f);
        }).catch(function(err) {
            return (0,log/* printError */.O)(err);
        });
    };
    var onPageChange = function(page) {
        return loadCompanyNewsFeed(page);
    };
    (0,react.useEffect)(function() {
        setPage(1);
        if (page === 1) {
            loadCompanyNewsFeed(1);
        }
    }, [
        props.shortname
    ]);
    (0,lib_page/* usePageChange */.ZF)({
        page: page,
        onChange: onPageChange,
        afterChange: function() {
            return (0,lib_page/* scrollToRef */.BC)({
                ref: ref,
                offset: 230
            });
        },
        dispatchOnMount: true
    });
    var LIMIT = 10;
    if (feed.data.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
            className: props.className,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                    title: "外部ニュース"
                }),
                feed.data.map(function(n, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsFeedItem, {
                        news: n
                    }, i);
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;padding-top:15px;padding-bottom:15px;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pagination/* Pagination */.t, {
                        limit: LIMIT,
                        count: feed.count,
                        page: page,
                        setPage: setPage
                    })
                })
            ]
        })
    });
};
var NewsFeedItem = function(props) {
    var url = isExternalNews(props.news) ? props.news.url : props.news.path;
    var src = isExternalNews(props.news) ? props.news.imageUrl : feedImg(props.news);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:15px;border-bottom:1px solid ", dist/* colors.gray50 */.O9.gray50, ";display:flex;flex-direction:row-reverse;grid-gap:16px;", dist.mq.large, "{flex-direction:row;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-basis:112px;flex-shrink:0;", dist.mq.large, "{flex-basis:144px;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    href: url,
                    target: "_blank",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;position:relative;border-radius:2px;&::before{content:'';display:block;width:100%;height:100%;background-color:transparent;border-radius:2px;position:absolute;transition:background-color 0.2s ease;}&:hover::before{background-color:rgba(0,0,0,0.08);}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
                        src: src
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            href: url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:15px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";line-height:1.5;color:", dist/* colors.black10 */.O9.black10, ";font-size:14px;text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;}", dist.mq.large, "{font-size:14px;}"),
                            children: props.news.title
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:4px;font-size:12px;line-height:1.25;color:", dist/* colors.textLight */.O9.textLight, ";"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                            children: props.news.publishedAt
                        })
                    })
                ]
            })
        ]
    });
};
var fallbackSrc = "/static/images/no-image.png";
var Image = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState({
        src: props.src || fallbackSrc,
        error: false
    }), 2), ref1 = ref[0], src = ref1.src, error = ref1.error, setState = ref[1];
    react.useEffect(function() {
        setState({
            src: props.src || fallbackSrc,
            error: false
        });
    }, [
        props.src
    ]);
    var handleError = react.useCallback(function() {
        setState({
            src: fallbackSrc,
            error: true
        });
    }, [
        error
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
        alt: "news feed image",
        src: src,
        onError: handleError,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;object-fit:contain;width:112px;aspect-ratio:1.91 / 1;border-radius:2px;", dist.mq.large, "{width:144px;}")
    });
};
var feedImg = function(feed) {
    switch(feed.feedType){
        case "notification":
            return "/static/images/feed/feed_notification.png";
        default:
            return "/static/images/no-image.png";
    }
};
var isExternalNews = function(item) {
    return item.url !== undefined;
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyOtherInfos.tsx










var CompanyOtherInfos = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            props.company.tradeNameHistories && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TradeNameHistoriesTable, {
                tradeNameHistories: props.company.tradeNameHistories
            }),
            props.company.addressHistories && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressHistoriesTable, {
                    addressHistories: props.company.addressHistories
                })
            }),
            (0,lib_company/* isPrivate */.hv)(props.company) && props.company.programHistories && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgramHistoriesTable, {
                    programHistories: props.company.programHistories
                })
            }),
            props.company.supporters && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SupportersTable, {
                    supporters: props.company.supporters
                })
            }),
            props.company.supportPrograms && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SupportProgramsTable, {
                    programs: props.company.supportPrograms
                })
            }),
            (0,lib_company/* isIPO */.sH)(props.company) && props.company.listingHistory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                            title: "上場履歴"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card.Content */.Zb.Content, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("white-space:pre-wrap;line-height:1.5;"),
                            children: props.company.listingHistory
                        })
                    ]
                })
            }),
            props.company.remarks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                            title: "備考"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card.Content */.Zb.Content, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("white-space:pre-wrap;line-height:1.5;"),
                            children: props.company.remarks
                        })
                    ]
                })
            })
        ]
    });
};
var TradeNameHistoriesTable = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "商号履歴"
            }),
            props.tradeNameHistories.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "変更年月"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "商号"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.tradeNameHistories.map(function(h, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: h.date
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: h.content
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
        ]
    });
};
var AddressHistoriesTable = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        id: "address-histories",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "登記住所変更履歴",
                helpText: "2015/10/5以降のデータのみ掲載"
            }),
            props.addressHistories.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "変更年月日"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "郵便番号"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "住所"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.addressHistories.map(function(h, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        empty: !h.changeDate,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                            children: h.changeDate
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: h.postCode
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: h.address
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
        ]
    });
};
var ProgramHistoriesTable = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "受賞歴"
            }),
            props.programHistories.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "受賞年月"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "受賞内容"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.programHistories.map(function(h, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        empty: !h.date,
                                        children: h.date
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: h.content
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
        ]
    });
};
var SupportersTable = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "支援元"
            }),
            props.supporters.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "ベンチャー支援"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "種別"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.supporters.map(function(s, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                            href: s.path,
                                            decoration: "none",
                                            children: s.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: s.category
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
        ]
    });
};
var SupportProgramsTable = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "支援プログラム"
            }),
            props.programs.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "タイトル"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "カテゴリ"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "説明"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.programs.map(function(p, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                            href: p.path,
                                            decoration: "none",
                                            children: p.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: p.category
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                                            lineNumber: 3,
                                            children: p.description
                                        })
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/PerformancesTable.tsx

function PerformancesTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                td {\n                  color: ",
        " !important;\n                }\n              "
    ]);
    PerformancesTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PerformancesTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              td {\n                color: ",
        " !important;\n              }\n            "
    ]);
    PerformancesTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var PerformancesTable = function(props) {
    if (!props.isEnterprise) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:", props.isEnterprise ? "initial" : "none", ";}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "期"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "年"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "月"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                children: [
                                    "区分",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                        children: "連結か単体かを示す"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                sub: "千円",
                                children: "売上"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                sub: "千円",
                                children: "営業利益 "
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                sub: "千円",
                                children: "経常利益"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                sub: "千円",
                                children: "当期利益"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "出所"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "備考"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:flex;justify-content:center;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                            align: "center",
                            colSpan: 10,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LimitedToEnterpriseContents, {})
                        })
                    })
                })
            ]
        });
    }
    if (props.performances.length === 0 && props.legacyPerformances.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {});
    }
    if (props.performances.length > 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "期"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "年"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "月"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                children: [
                                    "区分",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                        children: "連結か単体かを示す"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                sub: "千円",
                                children: "売上"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                sub: "千円",
                                children: "営業利益 "
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                sub: "千円",
                                children: "経常利益"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                sub: "千円",
                                children: "当期利益"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "出所"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                children: "備考"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                    children: props.performances.map(function(p, i) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            css: (0,emotion_react_browser_esm/* css */.iv)(PerformancesTable_templateObject(), p.estimated ? dist/* colors.gray70 */.O9.gray70 : dist/* colors.black30 */.O9.black30),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: p.period
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: p.year
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: p.month
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: p.reportType
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: (0,number/* formatWithComma */.m$)(p.sales)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: (0,number/* formatWithComma */.m$)(p.operatingProfit)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: (0,number/* formatWithComma */.m$)(p.ordinaryProfit)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: (0,number/* formatWithComma */.m$)(p.netIncome)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: p.sourceType
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    children: p.remarks
                                })
                            ]
                        }, i);
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "期"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "年"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "月"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                            children: [
                                "区分",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                    children: "連結か単体かを示す"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            sub: "千円",
                            children: "売上"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            sub: "千円",
                            children: "経常利益 "
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            sub: "千円",
                            children: "当期利益"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                            children: "備考"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                children: props.legacyPerformances.map(function(p, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        css: (0,emotion_react_browser_esm/* css */.iv)(PerformancesTable_templateObject1(), p.estimated ? dist/* colors.gray70 */.O9.gray70 : dist/* colors.black30 */.O9.black30),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: p.period
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: p.year
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: p.month
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: p.reportType
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: (0,number/* formatWithComma */.m$)(p.sales)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: (0,number/* formatWithComma */.m$)(p.ordinaryProfit)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: (0,number/* formatWithComma */.m$)(p.netIncome)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                children: p.remarks
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyShareholders.tsx











var CompanyShareholders = function(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;column-gap:32px;row-gap:16px;", dist.mq.untilMedium, "{flex-direction:column;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-basis:50%;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                        title: "機関投資家",
                        sub: "過去の株主を含む"
                    }),
                    props.institutionalShareholders.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:", props.isEnterprise ? "initial" : "none", ";}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                            children: "投資家名"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                            children: "最新ラウンド"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:flex;justify-content:center;}"),
                                children: props.isEnterprise ? (ref = props.institutionalShareholders) === null || ref === void 0 ? void 0 : ref.map(function(s, i) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                    href: s.investor.path,
                                                    decoration: "none",
                                                    children: s.investor.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: s.latestRoundDetail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                    href: s.latestRoundDetail.path,
                                                    decoration: "none",
                                                    className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                    children: s.latestRoundDetail.roundDate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                        children: s.latestRoundDetail.roundDate
                                                    }) : s.latestRoundDetail.shortname
                                                })
                                            })
                                        ]
                                    }, i);
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        colSpan: 2,
                                        align: "center",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LimitedToEnterpriseContents, {})
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-basis:50%;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                        title: "個人投資家"
                    }),
                    props.angelShareholders.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:", props.isEnterprise ? "initial" : "none", ";}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                            children: "人物"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                            children: "最新ラウンド"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:flex;justify-content:center;}"),
                                children: props.isEnterprise ? (ref1 = props.angelShareholders) === null || ref1 === void 0 ? void 0 : ref1.map(function(s, i) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                    href: s.investor.path,
                                                    decoration: "none",
                                                    children: s.investor.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: s.latestRoundDetail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                    href: s.latestRoundDetail.path,
                                                    decoration: "none",
                                                    className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                    children: s.latestRoundDetail.roundDate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                        children: s.latestRoundDetail.roundDate
                                                    }) : s.latestRoundDetail.shortname
                                                })
                                            })
                                        ]
                                    }, i);
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        colSpan: 2,
                                        align: "center",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LimitedToEnterpriseContents, {})
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/company/DomesticCompanyHeader.tsx + 2 modules
var DomesticCompanyHeader = __webpack_require__(22084);
// EXTERNAL MODULE: ./components/common/InviewForActiveTab.tsx
var InviewForActiveTab = __webpack_require__(53565);
// EXTERNAL MODULE: ./components/pages/companies/utils.ts
var utils = __webpack_require__(78331);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./lib/api/common.ts + 3 modules
var common = __webpack_require__(6140);
;// CONCATENATED MODULE: ./lib/api/company/domesticBenchmark.ts




var fetchDomesticBenchmarkCompanies = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(shortname) {
        var e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,common/* callAPI */.F)("".concat(common/* basePath */.sb, "/v1/companies/").concat(shortname, "/domestic_benchmarks"), {
                            credentials: "include"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,log/* printError */.O)(e);
                    return [
                        2,
                        {
                            domesticBenchmarkCompanies: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDomesticBenchmarkCompanies(shortname) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/DomesticBenchmarkTable.tsx

function DomesticBenchmarkTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      display: flex;\n                    "
    ]);
    DomesticBenchmarkTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DomesticBenchmarkTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        margin-left: 10px;\n                        flex: 1;\n                      "
    ]);
    DomesticBenchmarkTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DomesticBenchmarkTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                          display: flex;\n                        "
    ]);
    DomesticBenchmarkTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DomesticBenchmarkTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                                font-size: 15px;\n                              "
    ]);
    DomesticBenchmarkTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DomesticBenchmarkTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                              margin-left: 3px;\n                            "
    ]);
    DomesticBenchmarkTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DomesticBenchmarkTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                          font-size: 12px;\n                          line-height: 1.5;\n                        "
    ]);
    DomesticBenchmarkTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DomesticBenchmarkTable_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                          margin-top: 6px;\n                        "
    ]);
    DomesticBenchmarkTable_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DomesticBenchmarkTable_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                            color: #999;\n                            font-size: 11px;\n                          "
    ]);
    DomesticBenchmarkTable_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
















var DomesticBenchmarkTable = function(props) {
    var ref = (0,react.useState)([]), domesticBenchmarkCompanies = ref[0], setDomesticBenchmarkCompanies = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        setIsLoading(true);
        setDomesticBenchmarkCompanies([]);
        fetchDomesticBenchmarkCompanies(props.shortname).then(function(res) {
            setDomesticBenchmarkCompanies(res.domesticBenchmarkCompanies);
            setIsLoading(false);
        });
    }, [
        props.shortname
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        "data-test-id": "domestic-benchmark",
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "国内スタートアップ"
            }),
            isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingSpinner, {
                size: 3
            }) : domesticBenchmarkCompanies.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                "data-test-id": "domestic-benchmark-companies",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHead */.ss, {
                        dataTestId: "domestic-benchmark-companies-header",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> th{background-color:", dist/* colors.white10 */.O9.white10, " !important;}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "企業名"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "設立年月日"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    align: "center",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                children: "最新ラウンド"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                children: "調達日"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                    dataTestId: "initial-series",
                                    align: "center",
                                    help: "スピーダが独自に定義する成長フェーズ",
                                    helpProps: {
                                        linkTo: "https://help.initial.inc/ja/articles/4570885-initial%E3%82%B7%E3%83%AA%E3%83%BC%E3%82%BA",
                                        className: "help-icon"
                                    },
                                    children: [
                                        "スピーダ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                        "調達シリーズ"
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    align: "center",
                                    justify: "end",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                children: "総調達額"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneThousandYen, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    align: "center",
                                    justify: "end",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                children: "調達後評価額"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneThousandYen, {})
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: domesticBenchmarkCompanies.map(function(company, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableRow */.SC, {
                                highlightOnHover: true,
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        width: "50%",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: (0,emotion_react_browser_esm/* css */.iv)(DomesticBenchmarkTable_templateObject()),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/companies/".concat(company.shortname),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                        dataTestId: "company-logo",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                                            src: company.imageUrl || (0,lib_company/* companyDefaultImage */.tP)(company.isPublic ? "IPO企業" : "未公開企業"),
                                                            size: "normal",
                                                            name: company.name
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: (0,emotion_react_browser_esm/* css */.iv)(DomesticBenchmarkTable_templateObject1()),
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(DomesticBenchmarkTable_templateObject2()),
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                        href: "/companies/".concat(company.shortname),
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                                            decoration: "none",
                                                                            css: (0,emotion_react_browser_esm/* css */.iv)(DomesticBenchmarkTable_templateObject3()),
                                                                            dataTestId: "company-name",
                                                                            children: company.name
                                                                        })
                                                                    })
                                                                }),
                                                                company.isPublic && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IPOIcon/* IPOIcon */.K, {
                                                                    isHiddenTooltip: true,
                                                                    className: "ipo-label",
                                                                    css: (0,emotion_react_browser_esm/* css */.iv)(DomesticBenchmarkTable_templateObject4())
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                                                            justify: true,
                                                            lineNumber: 5,
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(DomesticBenchmarkTable_templateObject5()),
                                                            stripLineBreaks: true,
                                                            dataTestId: "description",
                                                            children: company.description
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(DomesticBenchmarkTable_templateObject6()),
                                                            children: company.tags && company.tags.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButtonGroup */.U, {
                                                                dataTestId: "tags",
                                                                children: company.tags.map(function(t) {
                                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                                                                        tag: t
                                                                    }, t.slug);
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        align: "left",
                                        dataTestId: "established",
                                        children: company.established
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        dataTestId: "last-funding-on",
                                        children: company.lastFundraised
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        dataTestId: "initial-series",
                                        children: company.isPublic ? "" : company.latestInitialSeries
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        align: "right",
                                        width: "10%",
                                        dataTestId: "total-fundraise",
                                        children: (0,utils/* formatNumber */.uf)(company.totalFunding)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        vertical: "middle",
                                        align: "right",
                                        width: "10%",
                                        children: company.valuation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    "data-test-id": "valuation-value",
                                                    children: (0,utils/* formatNumber */.uf)(company.valuation)
                                                }),
                                                company.isPublic && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    "data-test-id": "valuation-annotation",
                                                    css: (0,emotion_react_browser_esm/* css */.iv)(DomesticBenchmarkTable_templateObject7()),
                                                    children: "IPO前最終調達時"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {
                dataTestId: "domestic-benchmark-companies-empty",
                children: "データ未作成です"
            })
        ]
    });
};
var OneThousandYen = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:11px;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";"),
        children: "（千円）"
    });
};

;// CONCATENATED MODULE: ./components/pages/company/CompanyPage.tsx







































var STICKY_HEADER_OFFSET = "-190px";
var ref = (0,_sliced_to_array/* default */.Z)((0,InviewForActiveTab/* createInViewEventQueue */.ze)(), 2), push = ref[0], apply = ref[1];
var CompanyPage = function(props) {
    var ref;
    var user = (0,AuthContext/* useUser */.a)();
    // useReCaptchaOnMount('page_view', props.reCaptchaEnabled)
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,InviewForActiveTab/* setupActiveTabs */.ji)(CompanyTabGroup/* companyTabList */.q), 2), init = ref1[0], first = ref1[1];
    var ref2 = (0,react.useState)(init()), activeTabs = ref2[0], setActiveTabs = ref2[1];
    var ref3 = (0,react.useState)(true), isPopUpVisible = ref3[0], setIsPopUpVisible = ref3[1];
    var ref4 = (0,react.useState)(true), isFloatingBannerVisible = ref4[0], setIsFloatingBannerVisible = ref4[1];
    var handleChangeActive = function(tab, inView) {
        push(tab, inView, onTimeout);
    };
    var onTimeout = function() {
        setActiveTabs(apply(activeTabs));
    };
    var checkFooterInView = function() {
        var footer = document.getElementById("footer");
        if (footer === null) return;
        var footerHeight = footer.offsetTop - window.innerHeight;
        if (footerHeight < window.scrollY) {
            setIsPopUpVisible(false);
        } else {
            setIsPopUpVisible(true);
        }
    };
    var rootMargin = "".concat(STICKY_HEADER_OFFSET, " 0px");
    var throttledCheckFooterInView = (0,lodash.throttle)(checkFooterInView, 200);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", throttledCheckFooterInView);
        return function() {
            window.removeEventListener("scroll", throttledCheckFooterInView);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!props.company) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_error["default"], {
            err: {
                name: "Company",
                message: "doesn't exist"
            }
        });
    }
    if ((0,lib_user/* isGuest */.nJ)(user) && (0,lib_company/* isResearchDone */.UX)(props.company) && !(0,lib_company/* isExited */.EC)(props.company)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* CompanyHead */.CA, {
                    company: props.company,
                    children: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "viewport",
                        content: "width=1200px"
                    }, "viewport") : null
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Template/* Template */.Y, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DomesticCompanyHeader/* DomesticCompanyHeader */.I, {
                        company: props.company,
                        status: props.companyStatus,
                        memo: props.companyMemo,
                        contactPerson: props.companyContactPerson,
                        activeTab: first(activeTabs),
                        user: user
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* CompanyHead */.CA, {
                company: props.company,
                children: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "viewport",
                    content: "width=1200px"
                }, "viewport") : null
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Template/* Template */.Y, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DomesticCompanyHeader/* DomesticCompanyHeader */.I, {
                        company: props.company,
                        status: props.companyStatus,
                        memo: props.companyMemo,
                        contactPerson: props.companyContactPerson,
                        activeTab: first(activeTabs),
                        user: user
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.gray40 */.O9.gray40, ";padding-bottom:55px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:1200px;margin:0 auto;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                    tabName: "basic-info",
                                    onChangeActive: handleChangeActive,
                                    offset: "-12em",
                                    mobileOffset: "-5em",
                                    stickyOffset: rootMargin,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:24px;", dist.mq.untilMedium, "{padding-top:16px;}"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyBasicInfo, {
                                        company: props.company,
                                        smartroundUrl: props.smartroundUrl
                                    })
                                }),
                                (0,lib_user/* isGuest */.nJ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:64px 0 34px;", dist.mq.untilMedium, "{display:none;}"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksStaticBanner/* NewsPicksStaticBanner */.O, {
                                        staticBanner: props.staticBanners ? props.staticBanners[0] : null,
                                        trackingId: "companypage-static-banner"
                                    })
                                }),
                                (0,lib_user/* isGuest */.nJ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:16px;"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileGuestSlideBanner/* MobileGuestSlideBanner */.i, {
                                        slideBannerArticles: props.slideBannerArticles,
                                        trackingIdPrefix: "companypage"
                                    })
                                }),
                                (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                            tabName: "finance-info",
                                            onChangeActive: handleChangeActive,
                                            offset: "-12em",
                                            mobileOffset: "-5em",
                                            stickyOffset: rootMargin,
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                                    right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                                                        href: "https://help.initial.inc/ja/articles/5732414"
                                                    }),
                                                    children: "ファイナンス"
                                                }),
                                                (0,lib_company/* isPrivate */.hv)(props.company) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyFinanceInfo, {
                                                    info: props.company.financeBasicInfo,
                                                    withoutDilutiveShares: props.company.withoutDilutiveShares
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyFundingRounds, {
                                                    list: props.company.fundingRounds
                                                })
                                            ]
                                        }),
                                        (0,lib_company/* isIPO */.sH)(props.company) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                            tabName: "ipo-data",
                                            onChangeActive: handleChangeActive,
                                            offset: "-12em",
                                            mobileOffset: "-5em",
                                            stickyOffset: rootMargin,
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                                    right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                                                        href: "https://help.initial.inc/ja/articles/5732414"
                                                    }),
                                                    children: "IPOデータ"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyIPOData, {
                                                    ipoData: props.company.ipoData,
                                                    preIPOData: props.company.preIpoData,
                                                    ipoShareholders: props.company.ipoShareholders,
                                                    customLink: props.company.customLink
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                    tabName: "news",
                                    onChangeActive: handleChangeActive,
                                    offset: "-12em",
                                    mobileOffset: "-5em",
                                    stickyOffset: rootMargin,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:3rem;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                            children: "ニュース"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyFinanceNewsList, {
                                            financeNews: props.company.financeNews
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyNewsPicksFeeds, {
                                            shortname: props.company.shortname,
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-block-start:16px;", dist.mq.large, "{margin-block-start:24px;}")
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyNewsFeed, {
                                            shortname: props.company.shortname,
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-block-start:16px;", dist.mq.large, "{margin-block-start:24px;}"),
                                            feed: props.company.newsFeed
                                        })
                                    ]
                                }),
                                (0,lib_user/* isGuest */.nJ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:64px;", dist.mq.untilMedium, "{display:none;}"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksStaticBanner/* NewsPicksStaticBanner */.O, {
                                        staticBanner: props.staticBanners ? props.staticBanners[1] : null,
                                        trackingId: "companypage-static-banner-2"
                                    })
                                }),
                                (0,lib_company/* isPrivate */.hv)(props.company) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                    tabName: "shareholders",
                                    onChangeActive: handleChangeActive,
                                    offset: "-12em",
                                    mobileOffset: "-5em",
                                    stickyOffset: rootMargin,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                            sub: (0,lib_company/* isResearchContinue */.hD)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                            children: props.company.shareholdersUpdatedAt
                                                        })
                                                    }),
                                                    "更新"
                                                ]
                                            }) : "",
                                            right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                                                href: "https://help.initial.inc/ja/articles/5732414"
                                            }),
                                            children: "株主"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyShareholders, {
                                            institutionalShareholders: props.company.institutionalShareholders,
                                            angelShareholders: props.company.angelShareholders,
                                            isEnterprise: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                    tabName: "directors",
                                    onChangeActive: handleChangeActive,
                                    offset: "-12em",
                                    mobileOffset: "-5em",
                                    stickyOffset: rootMargin,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                            sub: (0,lib_company/* isResearchContinue */.hD)(props.company) && props.company.directorsUpdatedAt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                            children: props.company.directorsUpdatedAt
                                                        })
                                                    }),
                                                    "更新"
                                                ]
                                            }) : undefined,
                                            right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                                                href: "https://help.initial.inc/ja/articles/5732414"
                                            }),
                                            children: "役員"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DirectorsTable, {
                                            title: (0,lib_company/* isPrivate */.hv)(props.company) ? "役員（現職）" : "役員（IPO時）",
                                            directors: props.company.directors,
                                            isEnterprise: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                    tabName: "performances",
                                    onChangeActive: handleChangeActive,
                                    offset: "-12em",
                                    mobileOffset: "-5em",
                                    stickyOffset: rootMargin,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                            sub: (0,lib_company/* isPrivate */.hv)(props.company) && props.company.performancesUpdatedAt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                            children: props.company.performancesUpdatedAt
                                                        })
                                                    }),
                                                    "更新"
                                                ]
                                            }) : undefined,
                                            children: "業績"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PerformancesTable, {
                                            performances: props.company.performances,
                                            legacyPerformances: props.company.legacyPerformances,
                                            isEnterprise: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user)
                                        })
                                    ]
                                }),
                                ((ref = props.company.employeesShift) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                    tabName: "employees",
                                    onChangeActive: handleChangeActive,
                                    offset: "-12em",
                                    mobileOffset: "-5em",
                                    stickyOffset: rootMargin,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                            right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                                                href: "https://help.initial.inc/ja/articles/5732414"
                                            }),
                                            children: "従業員数"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmployeesShiftTable, {
                                            employeesShift: props.company.employeesShift,
                                            isEnterprise: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                    tabName: "partnerships",
                                    onChangeActive: handleChangeActive,
                                    offset: "-12em",
                                    mobileOffset: "-5em",
                                    stickyOffset: rootMargin,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                            right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                                                href: "https://help.initial.inc/ja/articles/5732414"
                                            }),
                                            children: "提携先"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PartnershipsTable, {
                                            partnerships: props.company.partnershipRounds,
                                            isEnterprise: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user)
                                        })
                                    ]
                                }),
                                (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                            tabName: "benchmarks",
                                            onChangeActive: handleChangeActive,
                                            offset: "-12em",
                                            mobileOffset: "-5em",
                                            stickyOffset: rootMargin,
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                                    className: "benchmark",
                                                    helpText: "類似企業の選定について",
                                                    helpProps: {
                                                        linkTo: "https://help.initial.inc/ja/articles/8687574",
                                                        className: "help-icon",
                                                        size: "large"
                                                    },
                                                    dataTestId: "benchmark-section-title",
                                                    children: "類似企業"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DomesticBenchmarkTable, {
                                                    shortname: props.company.shortname,
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:2rem;")
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseaBenchmarkMappingTable, {
                                                    shortname: props.company.shortname
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                            tabName: "others",
                                            onChangeActive: handleChangeActive,
                                            offset: "-12em",
                                            mobileOffset: "-5em",
                                            stickyOffset: rootMargin,
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:40px;", dist.mq.untilMedium, "{padding-top:32px;}"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                                    children: "その他"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyOtherInfos, {
                                                    company: props.company
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            (0,lib_user/* isGuest */.nJ)(user) && isPopUpVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileGuestFloatingBanner/* MobileGuestFloatingBanner */.V, {
                trackingIdPrefix: "companypage"
            }),
            (0,lib_user/* isGuest */.nJ)(user) && isFloatingBannerVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThumbnailFloatingBanner/* ThumbnailFloatingBanner */.G, {
                onClose: function() {
                    return setIsFloatingBannerVisible(false);
                },
                floatingBanner: props.floatingBanner,
                trackingIdPrefix: ""
            })
        ]
    });
};
/* harmony default export */ var company_CompanyPage = (CompanyPage);


/***/ }),

/***/ 56279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ DatasourceLink; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var DatasourceLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("a", {
        href: props.href,
        className: props.className,
        target: "_blank",
        rel: "noopener",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";"),
        children: "情報ソースについて"
    });
};


/***/ }),

/***/ 62610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ EmptyNumber; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var EmptyNumber = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
        "data-test-id": "empty-number",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black30 */ .O9.black30, ";padding-right:40px;&:after{content:'-';}")
    });
};


/***/ }),

/***/ 82263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CompanyInviewForActiveTab; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _common_InviewForActiveTab__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53565);




var CompanyInviewForActiveTab = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_common_InviewForActiveTab__WEBPACK_IMPORTED_MODULE_0__/* .InViewForActiveTab */ .Zv, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        offset: props.offset,
        mobileOffset: props.mobileOffset
    }));
};


/***/ }),

/***/ 67064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dg": function() { return /* binding */ equal; }
/* harmony export */ });
/* unused harmony exports indexBy, convertId, sortedKeysBy, sortedBy, subtract */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);




var indexBy = function(list, key) {
    return list.reduce(function(acc, item) {
        return _object_spread_props(_object_spread({}, acc), _define_property({}, key(item), item));
    }, {});
};
var convertId = function(list) {
    return list.map(function(item) {
        return _object_spread_props(_object_spread({}, item), {
            id: item.id.toString()
        });
    });
};
var sortedKeysBy = function(obj, by) {
    var order = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "asc";
    var sorted = Object.keys(obj).sort(function(k1, k2) {
        if (obj[k1][by] > obj[k2][by]) {
            return 1;
        }
        if (obj[k1][by] < obj[k2][by]) {
            return -1;
        }
        if (obj[k1].id > obj[k2].id) {
            return 1;
        }
        if (obj[k1].id < obj[k2].id) {
            return -1;
        }
        return 0;
    });
    return order === "asc" ? sorted : sorted.reverse();
};
var sortedBy = function(arr, by) {
    var order = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "asc";
    var sorted = arr.sort(function(k1, k2) {
        if (k1[by] > k2[by]) {
            return 1;
        }
        if (k1[by] < k2[by]) {
            return -1;
        }
        if (k1.id > k2.id) {
            return 1;
        }
        if (k1.id < k2.id) {
            return -1;
        }
        return 0;
    });
    return order === "asc" ? sorted : sorted.reverse();
};
var subtract = function(l1, l2) {
    return l1.filter(function(e) {
        return !l2.includes(e);
    });
};
var equal = function(l1, l2) {
    l1 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(l1);
    l2 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(l2);
    while(l1.length > 0){
        var element = l1.shift();
        var num = l2.indexOf(element);
        if (num === -1) {
            return false;
        }
        l2.splice(num, 1);
    }
    return l2.length === 0;
};


/***/ })

}]);